import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { Stack } from "@mui/material";
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import "layouts/style.css";
import { Bars } from 'react-loader-spinner'
import Select from "react-select"
import { saveCustomerPortalForm1 } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import CloseIcon from '@mui/icons-material/Close';
import { fetchKDSCustomer } from "assets/globalAPI/apiGlobal";
import {Dialog, DialogTitle, DialogContent, DialogActions, TextareaAutosize} from "@mui/material";
import Table from 'react-bootstrap/Table';
import {FormGroup, FormControlLabel} from "@mui/material";
import { fetchKDSMaterial } from "assets/globalAPI/apiGlobal";
import { fetchKDSVendor } from "assets/globalAPI/apiGlobal";
import { fetchApproverDetails } from "assets/globalAPI/apiGlobal";
import { updateCustomerMDM } from "assets/globalAPI/apiGlobal";
import { syncCustomerMDM } from "assets/globalAPI/apiGlobal";
import { fetchCustomerByCode } from "assets/globalAPI/apiGlobal";


const CustomerForm3=()=>{
    const navigate= useNavigate();
    const [loaderspinner, setLoaderSpinner] = useState(false);
    const [isMsme, setIsMsme] = useState(false);
    const [isfssi, setIsFssi] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [searchLoader, setSearchLoader] = useState(false);
    const [customerType, setCustomerType] = useState("");
    const toastId = React.useRef(null);
    const [loader, setLoader] = useState(false);
    const[firmtypes,setFirmTypes]= useState([]);
    const [formSubmitted, setIsFormSubmiteed] = useState(false);
    const contactEmail= localStorage.getItem("contactPersonEmail")
    const contactMobile= localStorage.getItem("contactPersonMobile")
    const [refID, setRefID] = useState(localStorage.getItem("refId") || ""); 
    const [kdsdata,setKdsData]= useState({});
    const [kdsdata2,setKdsData2]= useState({});
    const [kdsdata3,setKdsData3]= useState({});
    const [kdsdata4,setKdsData4]= useState({});
    const [dialogOpen,setDialogOpen]= useState(false);
    const [dialogOpen2,setDialogOpen2]= useState(false);
    const [dialogOpen3,setDialogOpen3]= useState(false);
    const [dialogOpen4,setDialogOpen4]= useState(false);
    const [searchTerm,setSearchTerm]= useState("");
    const [searchTerm2,setSearchTerm2]= useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [openComment, setOpenComment] = useState("");
     const [keySelected,setKeySelected]= useState("");
     const [godownUnit,setGodownUnit]= useState("");
        const [selectedField,setSelectedField]= useState("");
         const [custTitle,setCustTitle]= useState([])
         const [titleName,setTitleName]= useState("");
         const [userID,setUserID]=useState("")
        const [customerState,setCustomerState]= useState([])
        const [filteredZone,setFilteredZone]= useState([])
        const [saveForm,setSaveForm]= useState({})
         const [zData,setZData]= useState([]);
        const [stateSelected,setStateSelected]=useState("")
        const [selectedZoneName,setSelectedZoneName]=useState("")
          const [selectedKeyName,setSelectedKeyName]=useState("")
          const [typedCode,setTypedCode]= useState("");
          const [enteredEmployeeType,setEnteredEmployeeType]= useState("");
          const [panGSTError,setPanGSTError]= useState(false);
                        const [panGSTError2,setPanGSTError2]= useState(false);
                        const [stockistCode,setStockistCode]=useState(false);

    const [formValues, setFormValues] = useState({
      reference_id: '',
      
      firm_name: '',
      firm_status:'',
      street: '',
      co_name:'',
      po_box: '', 
      city: '',
      customer_type: '',
      district_name: '',
      block_tehsil: '',
      main_town_village: '', 
      post_office: '', 
      police_station: '',
      state: '', // State*
      pin_code: '', // Pin Code*
      proprietor_name: '', 
      proprietor_dob: '', 
      proprietor_email: '', 
      proprietor_mobile: '', 
      pan: '', 
      aadhaar: '', 
      cin: '', 
      roc_status:'', 
      inpln: '', 
      contact_person: '', 
      contact_person_email: '', 
      contact_person_mobile: '',
      mobile:'',
      email:'',
      contact_person_telephone: '',
      fssi_registration_status: '', 
      fssi_regn_no: '', 
      gstn: '', 
      tan: '', 
      bank_name: '',
      bank_branch_name: '',
      ifsc_code: '', // IFSC Code
      bank_account_number: '',
      undated_cheque_1: '',
      undated_cheque_2: '',
      undated_cheque_3: '',
      miscellaneous: '',
      companies: [
        { name_of_company: '', company_brand: '', monthly_turnover: '' }
      ],
      godown_area: '',
      godown_type: '',
      rcc_structure: '',
      del_type_rickshaw:'',
      del_type_van:'',
      model_no_van:'',
      customer_salesman_1: '',
      customer_salesman_no_1: '',
      customer_salesman_2: '',
      customer_salesman_no_2: '',
      customer_weekoff: '',
      date_of_fillup: new Date().toISOString().split('T')[0].replaceAll("-", ""),
      approved_by: userID,
      bp_grouping: '',
      sap_code: '',
      associated_to_sap_code: '',
      language: 'EN',
      search_term_1:'',
      search_term_2:'',
      company_code:'',
      customer_group:'',
      grouping_key:'',
      order_combination:'',
      reconciliation_account:'',
      account_assignment_group:'',
      account_statement:'',
      sort_key:'',
      payment_terms:'',
      payment_methods:'',
      sales_organisation:'',
      distribution_channel:'',
      division:'',
      sales_district:'',
      region:'',
      sub_group:'',
      zone:'',
      district_code:'',
      town_code:'',
      block_code:'',
      sales_office:'',
      sales_group:'',
      price_list:'',
      delivery_priority:'',
      order_probability:'',
      customer_pricing_procedure:'',
      shipping_conditions:'',
      bank_key:'',
      record_payment_history:'',
      withholding_tax_type:'',
      withholding_tax_type_2:'',
      withholding_tax_code:'',
      withholding_tax_code_2:'',
      withholding_tax_identification_number:'',
      withholding_tax_identification_number_2:'',
      withholding_agent:'',
      withholding_agent_2:'',
      withholding_start_date:'',
      withholding_start_date_2:'',
      tax_type_3:'',
      max_part_deliveries:'',
      incoterms:'',
      incoterms_location:'',
      fssiv: '',
      regdt: '',
      waers: 'INR',
      bscts: '',
      cknck: '',
      both0: '',
      rusk0: '',
      wafer: '',
      pan_stat: '',
      itr_stat: '',

      marketDetails: {
        Monday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: ""
          }
        ],
        Tuesday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          }
        ],
        Wednesday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          }
         
        ],
        Thursday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          },
        ],
        Friday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          },
        ],
        Saturday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          },
        ],
        Sunday: [
          {
            beatName_1: "",
            distanceFromGodown_1: "",
            expectedDailySales_1: "",
            retailer_1: "",
            wholesaler_1: "",
            frequencyOfVisit_1: "",
            readyStockOrOrderBooking_1: "",
            beatName_2: "",
            distanceFromGodown_2: "",
            expectedDailySales_2: "",
            retailer_2: "",
            wholesaler_2: "",
            frequencyOfVisit_2: "",
            readyStockOrOrderBooking_2: "",
          },
        ],
      },

      registration_type: '',
      concern_super_stockist: '',
      associated_to_sap_code:'',
      associated_to_sap_name: '', 
      sub_town_village_name: '', 
      working_town_village_name: '', 
      party_type: '', 
      date_of_association: '', 
      association_years: '',
      area_alloted: [
        { town_name: '', population: '', distance_from_godown: '',  }
      ],

      so_name:'',
      so_emp_code:'',
      so_email:'',
      so_date:'',
      asm_name:'',
      asm_emp_code:'',
      asm_email:'',
      asm_date:'',
      rsm_name:'',
      rsm_emp_code:'',
      rsm_email:'',
      rsm_date:'',
      zsm_name:'',
      zsm_emp_code:'',
      zsm_email:'',
      zsm_date:'',
      nsm_name:'',
      nsm_emp_code:'',
      nsm_email:'',
      nsm_date:'',
      dsm_name:'',
      dsm_emp_code:'',
      dsm_email:'',
      srm_name:'',
      srm_emp_code:'',
      srm_email:'',
      
      "targets": [
{
  "name": "Biscuits",
  "months": {
    "Apr": "",
    "May": "",
    "Jun": "",
    "Jul": "",
    "Aug": "",
    "Sep": "",
    "Oct": "",
    "Nov": "",
    "Dec": "",
    "Jan": "",
    "Feb": "",
    "Mar": "",
  }
},
{
  "name": "Cookies",
  "months": {
    "Apr": "",
    "May": "",
    "Jun": "",
    "Jul": "",
    "Aug": "",
    "Sep": "",
    "Oct": "",
    "Nov": "",
    "Dec": "",
    "Jan": "",
    "Feb": "",
    "Mar": "",
  }
},
{
  "name": "Cakes",
  "months": {
    "Apr": "",
    "May": "",
    "Jun": "",
    "Jul": "",
    "Aug": "",
    "Sep": "",
    "Oct": "",
    "Nov": "",
    "Dec": "",
    "Jan": "",
    "Feb": "",
    "Mar": "",
  }
},
{
  "name": "Rusk",
  "months": {
    "Apr": "",
    "May": "",
    "Jun": "",
    "Jul": "",
    "Aug": "",
    "Sep": "",
    "Oct": "",
    "Nov": "",
    "Dec": "",
    "Jan": "",
    "Feb": "",
    "Mar": "",
  }
},
{
  "name": "Wafer",
  "months": {
    "Apr": "",
    "May": "",
    "Jun": "",
    "Jul": "",
    "Aug": "",
    "Sep": "",
    "Oct": "",
    "Nov": "",
    "Dec": "",
    "Jan": "",
    "Feb": "",
    "Mar": "",
  }
}
]
    });

    function capitalizeInitials(str) {
      return str
        .split(/(\s+)/) // this keeps the spaces too
        .map(word => {
          return word.trim() ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word;
        })
        .join('');
    }

    const months = ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb","Mar"]

    useEffect(() => {
              const delayDebounce = setTimeout(() => {
                if (typedCode) {
                  fetchAllApprovers(typedCode,enteredEmployeeType);
                }
              }, 300); // 300ms debounce time
            
              return () => clearTimeout(delayDebounce);
            }, [typedCode]);
        
    
            const fetchAllApprovers=async(enteredCode,enteredName)=>{
              console.log("api called>>> ", enteredCode, enteredName)
              setIsActive(true);
              const body={
                empcode: enteredCode,
                empType: enteredName
              }
              console.log("body for approve>> ", body)
              try{
                const response= await fetchApproverDetails(body);
                const res= response.data;
                if(res.status){
                  console.log("fetched approvers>> ", res);
                  setIsActive(false)
                  if(res.result){
    
                    if(enteredName==="SO"){
                      let today = new Date();
                      let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
    
                      setFormValues((prevState) => ({
                        ...prevState,
                    
                        so_name: res.result.zsoName,
                       
                        so_email: res.result.zsoMailid,
                        so_date: yyyymmdd
                      }));
      
      
      
                    }else if(enteredName==="ASM"){
                      let today = new Date();
                      let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                      setFormValues((prevState) => ({
                        ...prevState,
                       
                        asm_name: res.result.zasmName,
                       
                        asm_email: res.result.zasmMailid,
                        asm_date: yyyymmdd
                      }));
      
                    } else if(enteredName==="RSM"){
                      let today = new Date();
                      let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                      setFormValues((prevState) => ({
                        ...prevState,
                        
                        rsm_name: res.result.zrsmName,
                       
                        rsm_email: res.result.zrsmMailid,
                        rsm_date: yyyymmdd
                      }));
                    }else if(enteredName==="ZSM"){
                      let today = new Date();
                      let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                      setFormValues((prevState) => ({
                        ...prevState,
                        
                        zsm_name: res.result.zzsmName,
                        
                        zsm_email: res.result.zzsmMailid,
                        zsm_date: yyyymmdd
                      }));
                    }else if(enteredName==="NSM"){
                      let today = new Date();
                      let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                      setFormValues((prevState) => ({
                        ...prevState,
                       
                        nsm_name: res.result.znsmName,
                        
                        nsm_email: res.result.znsmMailid,
                        nsm_date: yyyymmdd
                      }));
                    }else if(enteredName==="DSM"){
                      setFormValues((prevState) => ({
                        ...prevState,
                        
                        dsm_name: res.result.zdsmName,
                       
                        dsm_email: res.result.zdsmMailid,
                      }));
                    }else if(enteredName==="SRM"){
                      setFormValues((prevState) => ({
                        ...prevState,
                        
                        srm_name: res.result.zsrName,
                        
                        srm_email: res.result.zsrMailid,
                      }));
                    }
                  }else{
                    if(enteredName==="SO"){
                      let today = new Date();
                      let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
    
                      setFormValues((prevState) => ({
                        ...prevState,
                        so_emp_code:'',
                        so_name: '',
                       
                        so_email: '',
                        so_date: ''
                      }));
      
      
      
                    }else if(enteredName==="ASM"){
                      let today = new Date();
                      let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                      setFormValues((prevState) => ({
                        ...prevState,
                       asm_emp_code:'',
                        asm_name: '',
                       
                        asm_email: '',
                        asm_date: ''
                      }));
      
                    } else if(enteredName==="RSM"){
                      let today = new Date();
                      let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                      setFormValues((prevState) => ({
                        ...prevState,
                        rsm_emp_code:'',
                        rsm_name: '',
                       
                        rsm_email: '',
                        rsm_date: ''
                      }));
                    }else if(enteredName==="ZSM"){
                      let today = new Date();
                      let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                      setFormValues((prevState) => ({
                        ...prevState,
                        zsm_emp_code:'',
                        zsm_name: '',
                        
                        zsm_email: '',
                        zsm_date: ''
                      }));
                    }else if(enteredName==="NSM"){
                      let today = new Date();
                      let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                      setFormValues((prevState) => ({
                        ...prevState,
                       nsm_emp_code:'',
                        nsm_name: '',
                        
                        nsm_email: '',
                        nsm_date: ''
                      }));
                    }else if(enteredName==="DSM"){
                      setFormValues((prevState) => ({
                        ...prevState,
                        dsm_emp_code:'',
                        dsm_name: '',
                       
                        dsm_email: '',
                      }));
                    }else if(enteredName==="SRM"){
                      setFormValues((prevState) => ({
                        ...prevState,
                        srm_emp_code: '',
                        srm_name: '',
                        
                        srm_email: '',
                      }));
                    }
                  }
                  
                }else{
                  console.log("Could not bring approvers>> ", res);
                  setIsActive(false)
                  if(!toast.isActive(toastId.current)){
                    toastId.current= toast.warning("Could not bring approvers",{
                      className:"small-toast"
                    })
                  }
                }
              }catch(err){
                console.log("error fetching approver data>> ", err);
                setIsActive(false)
                if(!toast.isActive(toastId.current)){
                  toastId.current= toast.warning(err.message,{
                    className:"small-toast"
                  })
                }
                if(err.response?.status==403){
                  if(!toast.isActive(toastId.current)){
                    toastId.current= toast.error("Your Session Has Expired",{
                      className:"small-toast"
                    })
                  }
                  setTimeout(()=>{
                    navigate("/")
                    localStorage.clear();
                  },2000)
                }
              }
            }

            const convertToSnakeCase = (str) =>
                str.toLowerCase().replace(/\s+/g, "_").replace(/[^\w_]/g, "");


     const fetchAllCustomerKDS=async()=>{
                try{
                  const response= await fetchKDSMaterial();
                  const res= response.data;
                  if(res.status){
                    setKdsData(res.data)
                    console.log("kds fetched>> ", res.data);
                  }else{
                    console.log("could not bring material kds>> ", res)
                  }
                }catch(error){
                  console.log("error bringing material KDS>> ", error);
                }
              }

               const fetchAllCustomerKDS2=async()=>{
                              try{
                                const response= await fetchKDSCustomer();
                                const res= response.data;
                                if(res.status){
                                  setKdsData4(res.data)
                                  setCustTitle(res.data.title)
                                  setCustomerState(res.data.region)
                                  setZData(res.data.miszone)
                                  console.log("kds fetched for cust>> ", res.data);
                                }else{
                                  console.log("could not bring cust kds>> ", res)
                                }
                              }catch(error){
                                console.log("error bringing cust KDS>> ", error);
                              }
                            }

                            const fetchCustomerBySapCode=async()=>{
                                        setIsActive(true)
                                        const body={
              sap_code: stockistCode
            }
                                        try{
                                          const response= await fetchCustomerByCode(body);
                                          const res= response.data;
                                          if(res.status){
                                            setIsActive(false)
                                            // setKdsdata(res.data);
                                            if(res.data && res.data.trim()){
                            
                                              setFormValues(prev => ({
                                                   ...prev,
                                                   concern_super_stockist: stockistCode + '-' + res.data
                                                 }));
                                            }else{
                                               setFormValues(prev => ({
                                                   ...prev,
                                                   concern_super_stockist: ''
                                                 }));
                                            }
                                            // setZData(res.data.miszone)
                                            console.log("here is stockist details>> ", res)
                                            // console.log("kds fetched>> ", res.data);
                                          }else{
                                            setIsActive(false)
                                             setFormValues(prev => ({
                                                   ...prev,
                                                   concern_super_stockist: ''
                                                 }));
                                            console.log("could not bring stockist data>> ", res)
                                          }
                                        }catch(error){
                                          setIsActive(false)
                                           setFormValues(prev => ({
                                                   ...prev,
                                                   concern_super_stockist: ''
                                                 }));
                                          console.log("error bringing stockist data>> ", error);
                                        }
                                      }

                             const fetchAllVendorKDS=async()=>{
                                            try{
                                              const response= await fetchKDSVendor();
                                              const res= response.data;
                                              if(res.status){
                                                // setKdsData3(res.data)
                                                
                                                console.log("kds fetched vend>> ", res.data);
                                              }else{
                                                console.log("could not bring vendor kds>> ", res)
                                              }
                                            }catch(error){
                                              console.log("error bringing vendor KDS>> ", error);
                                            }
                                          }

    //  useEffect(() => {
    //       if (refID) {
    //         setFormValues((prevValues) => ({
    //           ...prevValues,
    //           reference_id: refID,
    //         }));
    //         console.log("ref id is>> ", refID)
    //       }
    //     }, [refID]);

    useEffect(() => {
      fetchAllCustomerKDS();
      fetchAllCustomerKDS2()
      fetchAllVendorKDS();
    //   let cust_type= localStorage.getItem("customer_type");
    //   console.log("hvgdhw>> ", cust_type)
      
    //     setCustomerType(cust_type);
    let userHere= JSON.parse(localStorage.getItem("userdetails"));
    setUserID(userHere.id)
    console.log("user id is>> ", userHere.id)

    const localForm = localStorage.getItem("editFormCustomerApprover");
    if (localForm) {
      const parsedForm = JSON.parse(localForm);
      setSaveForm(parsedForm)
      const updatedValues = {};

      
      updatedValues.reference_id = parsedForm.reference_id;
      updatedValues.approved_by = userHere.id
      updatedValues.extend = "X"
    
      Object.keys(formValues).forEach((key) => {
        if (key === "area_alloted"){

          if(parsedForm.areaDetails== null || parsedForm.areaDetails== undefined || parsedForm.areaDetails.length===0){
            updatedValues[key] = formValues.area_alloted;
            return
          }

          updatedValues[key] = parsedForm.areaDetails.map(detail => ({
            town_name: detail.town_name || '',
            population: detail.population || '',
            distance_from_godown: detail.distance_from_godown || ''
          }));
          console.log("updated areas>> "  ,updatedValues[key])
          return
        }
        if (key === "targets") {
          const updatedTargets = formValues.targets.map(target => {
            // filter the matching entries for this product_type
            const matchingEntries = parsedForm.targetDetails.filter(entry => entry.product_type === target.name);
          
            // clone the months object
            const updatedMonths = { ...target.months };
          
            // now, update months if data exists
            matchingEntries.forEach(entry => {
              if (updatedMonths.hasOwnProperty(entry.month)) {
                updatedMonths[entry.month] = entry.value;
              }
            });
          
            return {
              ...target,
              months: updatedMonths,
            };
          });
          
          console.log("here are updated targets>> ", updatedTargets)
          // finally update the formValues

          updatedValues.targets= updatedTargets
          // setFormValues(prev => ({
          //   ...prev,
          //   targets: updatedTargets,
          // }));
          return;
        };
        if (parsedForm.hasOwnProperty(key)) {
          if (key === "marketDetails" && Array.isArray(parsedForm.marketDetails)) {
            // Format marketDetails properly
            const formattedMarketDetails = {
              Monday: [],
              Tuesday: [],
              Wednesday: [],
              Thursday: [],
              Friday: [],
              Saturday: [],
              Sunday: []
            };
    
            parsedForm.marketDetails.forEach((detail) => {
              const day = detail.day;
              if (formattedMarketDetails[day]) {
                formattedMarketDetails[day].push(detail);
              }
            });
    
            updatedValues[key] = formattedMarketDetails;
          } else if (key === "godown_area") {
            const [area, unit] = parsedForm.godown_area.split(" ");
            updatedValues[key] = parsedForm.godown_area;
            setGodownUnit(unit); // Assuming you have a godownUnit state setter
          }
                   
         else {
            updatedValues[key] = parsedForm[key] || '';
          }
        } else {
          updatedValues[key] = formValues[key];
        }
      });

      const updated = updateFields(approvalFields.final, parsedForm);
      updatedValues.approved_by = userHere.id
      updatedValues.associated_to_sap_code= parsedForm.sap_code
      updatedValues.extend = "X"
      console.log("here is updated>> ", updated)
      setApprovalFields((prev) => ({ ...prev, final: updated }));

      // Object.keys(formValues).forEach((key) => {
      //   if (key === "targets" && Array.isArray(parsedForm.targetDetails)){

      //     const updatedTargets = formValues.targets.map(target => {
      //       // filter the matching entries for this product_type
      //       const matchingEntries = parsedForm.targetDetails.filter(entry => entry.product_type === target.name);
          
      //       // clone the months object
      //       const updatedMonths = { ...target.months };
          
      //       // now, update months if data exists
      //       matchingEntries.forEach(entry => {
      //         if (updatedMonths.hasOwnProperty(entry.month)) {
      //           updatedMonths[entry.month] = entry.value;
      //         }
      //       });
          
      //       return {
      //         ...target,
      //         months: updatedMonths,
      //       };
      //     });
          
      //     console.log("here are updated targets>> ", updatedTargets)
      //     // finally update the formValues
      //     setFormValues(prev => ({
      //       ...prev,
      //       targets: updatedTargets,
      //     }));
      //   }
      // })
    
    
      setFormValues(updatedValues);
     
      console.log("Updated simple form >>>", updatedValues);
    }
        
    },[]);
    

  //   const handleFormChange = (field, value) => {
  //     let updatedValue = value;
  
  //     // Check if the field is one of the multi-selects
  //     if (field === "nature_of_business" || field === "business_category") {
  //         // For multi-select fields, we need to extract the 'value' from the selected options array
  //         updatedValue = value.map(option => option.value);
  //     }
  
  //     // Update the state for the given field
  //     setFormValues((prevState) => ({
  //         ...prevState,
  //         [field]: {
  //             ...prevState[field],
  //             value: updatedValue,
  //         },
  //     }));
  // };

  useEffect(() => {
      const handler = setTimeout(() => {
        setSearchLoader(true); // Show loader AFTER 2 sec pause
        setDebouncedSearch(searchTerm);
    
        // Simulate async filtering (optional delay or set false immediately after)
        setTimeout(() => {
          setSearchLoader(false); // Hide loader after data is "ready"
        }, 100); // tweak delay if needed
      }, 600); // Wait for user to stop typing
    
      return () => clearTimeout(handler); // Cleanup if typing again
    }, [searchTerm]);
  
    useEffect(() => {
      const handler = setTimeout(() => {
        setSearchLoader(true); // Show loader AFTER 2 sec pause
        setDebouncedSearch(searchTerm2);
    
        // Simulate async filtering (optional delay or set false immediately after)
        setTimeout(() => {
          setSearchLoader(false); // Hide loader after data is "ready"
        }, 100); // tweak delay if needed
      }, 600); // Wait for user to stop typing
    
      return () => clearTimeout(handler); // Cleanup if typing again
    }, [searchTerm2]);

  const filteredData = kdsdata.matuom?.filter(
    (item) =>
      item.label.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
      item.value.toLowerCase().includes(debouncedSearch.toLowerCase())
  );

   const [approvalFields, setApprovalFields] = useState({
            final: [
              { name: "BP Grouping", type: "dropdown", block: "General Data", apiKey: "bpgrp", option: [{}] },
              { name: "Customer Code", type: "text", block: "General Data", value: "" },
              { name: "Language", type: "text", block: "General Data", value: "EN" },
              { name: "Search Term 1", type: "text", block: "General Data", value: "" },
              { name: "Search Term 2", type: "text", block: "General Data", value: "" },
              { name: "Company Code", type: "dropdown", block: "Company Code Data", apiKey: "compcode", option: [{}] },
              { name: "Customer Group", type: "dropdown", block: "Sales Data", apiKey: "custgrp", option: [{}] },
              { name: "Grouping Key", type: "text", block: "Company Code Data", value: "" },
              { name: "Order Combination", type: "checkbox", block: "Sales Data", value: false },
              { name: "Reconciliation account", type: "dropdown", block: "Company Code Data", apiKey: "reconacc", option: [{}] },
              { name: "Account Assignment Group", type: "dropdown", block: "Company Code Data", apiKey: "custacntgrp", option: [{}] },
              { name: "Account Statement", type: "text", block: "Company Code Data", value: "" },
              { name: "Sort key", type: "dropdown", block: "Company Code Data", apiKey: "sortkey", option: [{}] },
              { name: "Payment Terms", type: "dropdown", block: "Company Code Data", apiKey: "payterms", option: [{}] },
              { name: "Payment Methods", type: "dropdown", block: "Company Code Data", apiKey: "paymthd", option: [{}] },
              { name: "Sales Organisation", type: "dropdown", block: "Sales Data", apiKey: "salesorg", option: [{}] },
              { name: "Distribution Channel", type: "dropdown", block: "Sales Data", apiKey: "distchnl", option: [{}] },
              { name: "Division", type: "dropdown", block: "Sales Data", apiKey: "division", option: [{}] },
              { name: "Sales District", type: "dropdown", block: "Sales Data", apiKey: "saldstrct", option: [{}] },
              { name: "Sales Office", type: "dropdown", block: "Sales Data", apiKey: "saleofc", option: [{}] },
              { name: "Sales Group", type: "dropdown", block: "Sales Data", apiKey: "salegrpofcmap", option: [{}] },
              { name: "Price List", type: "dropdown", block: "Sales Data", apiKey: "priclst", option: [{}] },
              { name: "Delivery Priority", type: "dropdown", block: "Sales Data", apiKey: "dlvprty", option: [{}] },
              { name: "Region", type: "dropdown", block: "Sales Data", apiKey: "region", option: [{}] },
              { name: "Sub Group", type: "dropdown", block: "Sales Data", apiKey: "zgrp", option: [{}] },
              { name: "Zone", type: "dropdown", block: "Sales Data", apiKey: "zzone", option: [{}] },
              { name: "District Code", type: "text", block: "Sales Data", value: "" },
              { name: "Town Code", type: "text", block: "Sales Data", value: "" },
              { name: "Block Code", type: "text", block: "Sales Data", value: "" },
              { name: "Order Probability", type: "text", block: "Sales Data", value: "" },
              { name: "Currency", type: "dropdown", block: "Sales Data", apiKey: "ordrcurr", option: [{}] },
              { name: "Customer Pricing Procedure", type: "dropdown", block: "Sales Data", apiKey: "pricprcd", option: [{}] },
              { name: "Shipping Conditions", type: "dropdown", block: "Sales Data", apiKey: "shipcond", option: [{}] },
              { name: "Bank Key", type: "dropdown", block: "General Data", apiKey: "bankkey", option: [{}] },
              { name: "Record Payment History", type: "checkbox", block: "Company Code Data", value: false },
              { name: "Withholding Tax Type", type: "dropdown", block: "Company Code Data", apiKey: "witall", option: [{}] },
              { name: "Withholding Tax Code", type: "dropdown", block: "Company Code Data", apiKey: "witall", option: [{}] },
              { name: "Withholding Tax Identification Number", type: "text", block: "Company Code Data", value: "" },
              { name: "Withholding Agent", type: "checkbox", block: "Company Code Data", value: false },
              { name: "Withholding Start Date", type: "date", block: "Company Code Data", value: "" },
              { name: "Withholding Tax Type 2", type: "dropdown", block: "Company Code Data", apiKey: "witall", option: [{}] },
              { name: "Withholding Tax Code 2", type: "dropdown", block: "Company Code Data", apiKey: "witall", option: [{}] },
              { name: "Withholding Tax Identification Number 2", type: "text", block: "Company Code Data", value: "" },
              { name: "Withholding Agent 2", type: "checkbox", block: "Company Code Data", value: false },
              { name: "Withholding Start Date 2", type: "date", block: "Company Code Data", value: "" },
              { name: "Tax Type 3", type: "dropdown", block: "Company Code Data", apiKey: "taxtype", option: [{}] },
              { name: "Max Part Deliveries", type: "text", block: "Sales Data", value: "" },
              { name: "Incoterms", type: "dropdown", block: "Sales Data", apiKey: "incoterms", option: [{}] },
              { name: "Incoterms Location", type: "text", block: "Sales Data", value: "" },
              { name: "FSSAI Validity Date", type: "date2", block: "Sales Data", value: "" },
              { name: "Date Of Registration", type: "date2", block: "General Data", value: "" },
              { name: "PAN Status", type: "select", block: "General Data", option: [{ value: "OPERATIVE", label: "Operative" }, { value: "INOPERATIVE", label: "Inoperative" }], value:"" },
              { name: "ITR Start", type: "select", block: "General Data", option: [{ value: "YES", label: "Yes" }, { value: "NO", label: "No" }], value:"" },
              { name: "Biscuits", type: "checkbox", block: "General Data", value: false },
              { name: "Cakes", type: "checkbox", block: "General Data", value: false },
              { name: "Cookies", type: "checkbox", block: "General Data", value: false },
              { name: "Rusk", type: "checkbox", block: "General Data", value: false },
              { name: "Wafer", type: "checkbox", block: "General Data", value: false },
            ]
            
          });

        

  const updateFields = (fields, data) => {
    const fieldMapping = {
      bscts: "Biscuits",
      cknck: "Cakes",
      both0: "Cookies",
      rusk0: "Rusk",
      waers: "Currency",
      pan_stat: "PAN Status",
      itr_stat: "ITR Start",
      regdt: "Date Of Registration",
      fssiv: "FSSAI Validity Date",
      sap_code: "Customer Code",
    };
  
    return fields.map((field) => {
      const fieldKey = field.name==="Currency"? field.name : convertToSnakeCase(field.name);
  
      // direct match
      if (fieldKey in data) {
        return {
          ...field,
          value: data[fieldKey],
        };
      }
  
      // reverse lookup after converting mapping value to snake_case
      const mappedKey = Object.keys(fieldMapping).find((k) =>
        fieldMapping[k] === "Currency"
          ? fieldMapping[k] === fieldKey
          : convertToSnakeCase(fieldMapping[k]) === fieldKey
      );
      
  
      if (mappedKey && mappedKey in data) {
        return {
          ...field,
          value: data[mappedKey],
        };
      }
  
      return field;
    });
  };

  const handleFormChange = (field, value, index = null, day = null) => {
    if(field==="godown_unit"){
      setGodownUnit(value)
      setFormValues(prev => ({
        ...prev,
        godown_area: prev.godown_area.split(" ")[0] + (value ? ` ${value}` : ""),
        approved_by: userID
      }));
      setDialogOpen(false)
      setDialogOpen2(false)
      return;
    }

    if (field === "godown_area") {
        console.log("god unit>> ", godownUnit)
        setFormValues((prev) => ({
            ...prev,
            [field]: value + (godownUnit ? ` ${godownUnit}` : ""),
            approved_by: userID
        }));

        return;
    }
    
    setFormValues((prevState) => {
        let updatedState = { ...prevState };


        

        // Update companies only if index is provided and day is null
        if (index !== null && day === null) {
            const updatedCompanies = [...prevState.companies];
            updatedCompanies[index] = {
                ...updatedCompanies[index],
                [field]: value,
            };
            updatedState.companies = updatedCompanies;
            updatedState.approved_by = userID
        } 
        
        // Update marketDetails only if day is provided
        else if (day !== null && index !== null) {
          const updatedDays = { ...prevState.marketDetails };
          updatedDays[day][index] = {
              ...updatedDays[day][index],
              [field]: value,
          };
          updatedState.marketDetails = updatedDays;
          updatedState.approved_by = userID
      } 
        // General field update
        else {
            updatedState[field] = value;
            updatedState.approved_by = userID
            setSearchTerm2("")
            setSearchTerm("")
        }

        console.log("here is formValues after change>> ", formValues)
        // setDialogOpen(false)
        setDialogOpen2(false)
        setSearchTerm2("")

        return updatedState;
    });
};

const handleFormChange2 = (field, value, index = null, materialIndex = null) => {
  setFormValues((prevState) => {
      let updatedState = { ...prevState };

      // Update `area_alloted` when index is provided but materialIndex is null
      if (index !== null && materialIndex === null) {
          const updatedAreaAlloted = [...prevState.area_alloted];
          updatedAreaAlloted[index] = {
              ...updatedAreaAlloted[index],
              [field]: value,
          };
          updatedState.area_alloted = updatedAreaAlloted;
          updatedState.approved_by = userID
      }

      // Update `targets` for a specific material and month
      if (materialIndex !== null) {
          const updatedTargets = [...prevState.targets];
          updatedTargets[materialIndex] = {
              ...updatedTargets[materialIndex],
              months: {
                  ...updatedTargets[materialIndex].months,
                  [field]: value,
              },
          };
          updatedState.targets = updatedTargets;
          updatedState.approved_by = userID
      }

      // General field update if neither `index` nor `materialIndex` is provided
      if (index === null && materialIndex === null) {
        // if (field === "date_of_association") {
        //   const dateObj = new Date(value);
        //   const day = String(dateObj.getDate()).padStart(2, '0');
        //   const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        //   const year = dateObj.getFullYear();
        //   updatedState[field] = `${year}${month}${day}`;
        // }
        
          updatedState[field] = value;
          updatedState.approved_by = userID
          
      }

      return updatedState;
  });
};

const handleChange = (name, value) => {
    console.log("Name:", name, "Value:", value);  
    const fieldKeyMap = {
      "FSSAI Validity Date": "fssiv",
      "Date Of Registration": "regdt",
      "Currency": "waers",
      "Biscuits": "bscts",
      "Cakes": "cknck",
      "Cookies": "both0",
      "Rusk": "rusk0",
      "PAN Status": "pan_stat",
      "ITR Start": "itr_stat",
      "Customer Code": "sap_code",
    };

//           const today = new Date();
// const yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;



if (name === "Withholding Tax Type 2") {

const [typeVal, codeVal] = value.includes('#') ? value.split('#') : [value, ""];

  setFormValues(prev => ({
    ...prev,
    withholding_tax_type_2: typeVal || "",
    approved_by:userID
  }));

  setApprovalFields(prev => {
    const updatedFields = prev.final.map(field => {
      if (field.name === "Withholding Tax Type 2") {
        return { ...field, value: typeVal || "" };
      }
      return field;
    });
    return { final: updatedFields };
  });

setDialogOpen(false);
setDialogOpen2(false);
setDialogOpen3(false);
setSearchTerm("");
setSearchTerm2("");

} else if (name === "Withholding Tax Code 2") {

const [typeVal, codeVal] = value.includes('#') ? value.split('#') : ["", value];

  setFormValues(prev => ({
    ...prev,
    withholding_tax_code_2: codeVal || "",
    approved_by: userID
  }));

  setApprovalFields(prev => {
    const updatedFields = prev.final.map(field => {
      if (field.name === "Withholding Tax Code 2") {
        return { ...field, value: codeVal || "" };
      }
      return field;
    });
    return { final: updatedFields };
  });

setDialogOpen(false);
setDialogOpen2(false);
setDialogOpen3(false);
setSearchTerm("");
setSearchTerm2("");

} else if (name === "Withholding Tax Type" || name === "Withholding Tax Code") {

const [typeVal = "", codeVal = ""] = value ? value.split('#') : ["", ""];

  setFormValues(prev => ({
    ...prev,
    withholding_tax_type: typeVal,
    withholding_tax_code: codeVal,
    approved_by: userID
  }));

  setApprovalFields(prev => {
    const updatedFields = prev.final.map(field => {
      if (field.name === "Withholding Tax Type") {
        return { ...field, value: typeVal };
      }
      if (field.name === "Withholding Tax Code") {
        return { ...field, value: codeVal };
      }
      return field;
    });
    return { final: updatedFields };
  });

setDialogOpen(false);
setDialogOpen2(false);
setDialogOpen3(false);
setSearchTerm("");
setSearchTerm2("");

} else {
const key = fieldKeyMap[name] || name
.toLowerCase()
.replace(/[^a-z0-9]+/g, '_')
.replace(/^_+|_+$/g, '');

setFormValues(prev => ({
...prev,
[key]: value,
approved_by: userID

}));

setApprovalFields(prev => {
const updatedFields = prev.final.map(field =>
field.name === name ? { ...field, value } : field
);
console.log("here are updated fields in approvalFields>> ", updatedFields);
return { final: updatedFields };
});

setDialogOpen(false);
setDialogOpen2(false);
setDialogOpen3(false);
setDialogOpen4(false);
setSearchTerm("");
setSearchTerm2("");
}

  };


  const handleDropdownClick = (keyName,field) => {
    if(field==="Zone"){
      setIsActive(true)
      let filteredData = zData
      .map(item => item[keyName])
      .filter(value => value && value.trim() !== '');
      setFilteredZone(filteredData)
      console.log("Filtered zone>>> ", filteredData)
      setKeySelected(keyName);
    setSelectedField(field)
      setDialogOpen4(true);
      setIsActive(false)
      return;
    }
    if(field==="Sub Group"){
      let filteredData = zData
      .map(item => item[keyName])
      .filter(value => value && value.trim() !== '');
      setFilteredZone(filteredData)
      console.log("Filtered zone>>> ", filteredData)
      setKeySelected(keyName);
    setSelectedField(field)
      setDialogOpen4(true);
      return;
    }
    console.log("here is key and name>> ", keyName, field)
    setKeySelected(keyName);
    setSelectedField(field)
    setDialogOpen3(true);      // Open the dialog
  };




  // const handleFormChange = (index, field, value) => {
  //   setFormValues((prevState) => {
  //     const updatedCompanies = [...prevState.companies];
  //     updatedCompanies[index] = {
  //       ...updatedCompanies[index],
  //       [field]: { ...updatedCompanies[index][field], value },
  //     };
  //     return { ...prevState, companies: updatedCompanies };
  //   });
  // };

  function formatDate(value) {
    if (!value) return '';
  
    // If value is already in YYYYMMDD format
    if (typeof value === 'string' && value.length === 8 && /^\d{8}$/.test(value)) {
      const year = value.substring(0, 4);
      const month = value.substring(4, 6);
      const day = value.substring(6, 8);
      return `${year}-${month}-${day}`;
    }
  
    // If value is in YYYY-MM-DD or similar format
    const dateObj = new Date(value);
  
    // If date is valid, format it
    if (!isNaN(dateObj.getTime())) {
      return dateObj.toISOString().split('T')[0];
    }
  
    // If invalid, don't touch it. Let the user keep typing.
    return value;
  }

  const addRow = () => {
    setFormValues((prevState) => ({
      ...prevState,
      companies: [
        ...prevState.companies,
        { name_of_company: '', company_brand: '', monthly_turnover: '' }
      ],
    }));
  };
  const addRowArea = () => {
    setFormValues((prevValues) => ({
      ...prevValues,
      area_alloted: [...prevValues.area_alloted, { town_name: '', population: '', distance_from_godown: '' }]
    }));
  };

  const removeRowArea = (index) => {
    setFormValues((prevValues) => {
      const updatedAreaAlloted = [...prevValues.area_alloted];
      updatedAreaAlloted.splice(index, 1);
      return { ...prevValues, area_alloted: updatedAreaAlloted };
    });
  };

  const addRowMarket = (day) => {
    setFormValues((prevState) => {
      const updatedDays = { ...prevState.marketDetails };
      updatedDays[day].push({
        beatName: "",
        distanceFromGodown: "",
        expectedDailySales: "",
        retailer: "",
        wholesaler: "",
        frequencyOfVisit: "",
        readyStockOrOrderBooking: "",
      });
  
      return { ...prevState, marketDetails: updatedDays };
    });
  };

  const removeRowMarket = (day, index) => {
    setFormValues((prevState) => {
      const updatedDays = { ...prevState.marketDetails };
      
      if (updatedDays[day].length > 1) {
        updatedDays[day].splice(index, 1);
      }
  
      return { ...prevState, marketDetails: updatedDays };
    });
  };


  const fieldDisplayNames2 = {
    "BP Grouping": "BP Grouping*",
    "Customer Code": "Customer Code",
    "Language": "Language*",
    "Search Term 1": "Search Term 1*",
    "Search Term 2": "Search Term 2",
    "Company Code": "Company Code*",
    "Customer Group":formValues.customer_type!=="Sub Distributor" ?"Customer Group*": "Customer Group",
    "Grouping Key": "Grouping Key",
    "Order Combination": "Order Combination",
    "Reconciliation account": "Reconciliation account*",
    "Account Assignment Group": "Account Assignment Group",
    "Account Statement": "Account Statement",
    "Sort key": "Sort key",
    "Payment Terms": "Payment Terms",
    "Payment Methods": "Payment Methods",
    "Sales Organisation": "Sales Organisation*",
    "Distribution Channel": "Pin Distribution Channel*",
    "Division": "Division*",
    "Sales District": "Sales District",
    "Sales Office": "Sales Office*",
    "Sales Group": "Sales Group*",
    "Price List":formValues.customer_type!=="Sub Distributor" ? "Price List*" :"Price List",
    "Shipping Conditions": "Shipping Conditions*",
    "Customer Pricing Procedure": "Customer Pricing Procedure*",
    "Delivery Priority": "Delivery Priority",
    "Region": "Region*",
    "Sub Group": "Sub Group*",
    "Zone": "Zone*",
    "District Code": "District Code",
    "Town Code": "Town Code",
    "Block Code": "Block Code",
    "Order Probability": "Order Probability",
    "Currency": "Currency*",
    "Record Payment History": "Record Payment History",
    "Withholding Tax Type": formValues.customer_type!=="Sub Distributor" ? "Withholding Tax Type*" : "Withholding Tax Type",
  "Withholding Tax Code": formValues.customer_type!=="Sub Distributor" ? "Withholding Tax Code*" : "Withholding Tax Code",
  "Withholding Tax Identification Number": formValues.customer_type!=="Sub Distributor" ? "Withholding Tax Identification Number*" : "Withholding Tax Identification Number",
  "Withholding Agent": formValues.customer_type!=="Sub Distributor" ? "Withholding Agent*" : "Withholding Agent",
  "Withholding Start Date": formValues.customer_type!=="Sub Distributor" ? "Withholding Start Date*" : "Withholding Start Date",
  "Withholding Tax Type 2": formValues.customer_type!=="Sub Distributor" ? "Withholding Tax Type 2*" : "Withholding Tax Type 2",
  "Withholding Tax Code 2": "Withholding Tax Code 2", // no asterisk regardless
  "Withholding Tax Identification Number 2": formValues.customer_type!=="Sub Distributor" ? "Withholding Tax Identification Number 2*" : "Withholding Tax Identification Number 2",
  "Withholding Agent 2": formValues.customer_type!=="Sub Distributor" ? "Withholding Agent 2*" : "Withholding Agent 2",
  "Withholding Start Date 2": formValues.customer_type!=="Sub Distributor" ? "Withholding Start Date 2*" : "Withholding Start Date 2",
          "Tax Type 3":formValues.customer_type!=="Sub Distributor"? "Tax Type 3*": "Tax Type 3",
    "Max Part Deliveries": "Max Part Deliveries",
    "Incoterms": "Incoterms",
    "Incoterms Location": "Incoterms Location",
    "FSSAI Validity Date": "FSSAI Validity Date",
    "Date Of Registration": "Date Of Registration*",
    "PAN Status": "PAN Status",
    "ITR Start": "ITR Start",
    "Biscuits": "Biscuits",
    "Cakes": "Cakes",
    "Cookies": "Cookies",
    "Rusk": "Rusk",
    "Wafer": "Wafer",
  };
  
  
  
  const removeRow = (index) => {
    setFormValues((prevState) => {
      const updatedCompanies = prevState.companies.filter((_, i) => i !== index);
      return { ...prevState, companies: updatedCompanies };
    });
  };
  

      const handleSubmitForm=async(e)=>{
        e.preventDefault();
        setIsActive(true)
        console.log("here is the final form>> ", formValues)
        setIsFormSubmiteed(true);

        const { sub_town_village_name, working_town_village_name, party_type, targets } = formValues;
        
        // Get month string like 'May' from date_of_fillup
        let selectedCust= JSON.parse(localStorage.getItem("editFormCustomerApprover"))
        const monthIndex = Number(selectedCust.date_of_fillup?.substring(4, 6)); // e.g., "05"
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const targetMonth = monthNames[monthIndex - 1]; // Convert number to month name like 'May'
        
        const isBasicInfoMissing =
          !sub_town_village_name.trim() ||
          !working_town_village_name.trim() ||
          !party_type.trim();
        
        const isTargetMonthMissing = targets.some(item => !item.months[targetMonth]?.trim());
        
        if (isBasicInfoMissing || isTargetMonthMissing) {
          setIsActive(false);
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error(
              `Please fill all mandatory fields: Sub Town/Village, Working Town/Village, Party Type and the "${targetMonth}" target.`,
              { className: "small-toast" }
            );
          }
          return;
        }
         if(formValues.registration_type=="Replacement"){
              if(formValues.associated_to_sap_code==""){
                if (!toast.isActive(toastId.current)) {
                  toastId.current = toast.error(
                    `Please fill the associated to sap code for replacement.`,
                    { className: "small-toast" }
                  );
                }
                setIsActive(false);
                return;
              }
            }
             if (formValues.customer_type == "Sub Distributor" && !formValues.concern_super_stockist?.trim()) {
                      setIsActive(false);
                      if (!toast.isActive(toastId.current)) {
                        toastId.current = toast.error(
                          `Please fill the Concern Super Stockist for Sub Distributor.`,
                          { className: "small-toast" }
                        );
                      }
                      return;
                    }
         const requiredFields = [
                  "firm_name", "firm_status", "city","street",
                  "state", "pin_code","district_name", "proprietor_name", "proprietor_email", "proprietor_mobile","proprietor_dob","gstn", "pan",
                  "contact_person", "contact_person_email", "contact_person_mobile"
                   
                ];
        
                const godownAreaFilled = formValues.godown_area && formValues.godown_area.trim() !== '';
                const godownUnitFilled = godownUnit && godownUnit.trim() !== '';
        
                
                
                let hasError = false;
                let updatedValues = { ...formValues };
                let missingFields = [];
                
                requiredFields.forEach((key) => {
              if (godownAreaFilled) {
                if(!godownUnitFilled){
                  hasError = true;
                  missingFields.push("godown_unit");
                }
                // hasError = true;
                // if (!godownAreaFilled) missingFields.push("godown_area");
              }
              const value = updatedValues[key];
            
              if (typeof value === 'string') {
                if (value.trim() === '') {
                  hasError = true;
                  missingFields.push(key.replace(/_/g, ' '));
                } else {
                  updatedValues[key] = value.trim();
                }
              } else if (value === undefined || value === null) {
                hasError = true;
                missingFields.push(key.replace(/_/g, ' '));
              }
            });
            
        
            setFormValues(updatedValues); 
             if (hasError) {
                  console.log("cannot submit, fill mandatory")
                  if (!toast.isActive(toastId.current)) {
                    toastId.current = toast.error(`Please fill all required fields: ${missingFields}`, {
                      className: "small-toast"
                    });
                  }
                  
                  setIsActive(false);
                  
                  return;
                }
                const mandatoryFields = [
                  { key: 'customer_pricing_procedure', label: 'Customer Pricing Procedure' },
                  { key: 'bp_grouping', label: 'BP Grouping' },
                  { key: 'shipping_conditions', label: 'Shipping Condition' },
                  { key: 'region', label: 'Region' },
                  { key: 'company_code', label: 'Company Code' },
                  // { key: 'payment_terms', label: 'Payment Terms' },
                  { key: 'reconciliation_account', label: 'Reconciliation account' },
                  // { key: 'payment_methods', label: 'Payment Methods' },
                  { key: 'sales_office', label: 'Sales Office' },
                  { key: 'sales_group', label: 'Sales Group' },
                  { key: 'sub_group', label: 'Sub Group' },
                  { key: 'zone', label: 'Zone' },
                  { key: 'customer_pricing_procedure', label: 'Customer Pricing Procedure' },
                  { key: 'shipping_conditions', label: 'Shipping Conditions' },
                ];
                if (formValues.customer_type !== "Sub Distributor") {
                  mandatoryFields.push(
                    { key: 'withholding_tax_type', label: 'Withholding Tax Type' },
                    { key: 'withholding_tax_code', label: 'Withholding Tax Code' },
                    { key: 'withholding_tax_identification_number', label: 'Withholding Tax Identification Number' },
                    { key: 'withholding_agent', label: 'Withholding Agent' },
                    { key: 'withholding_start_date', label: 'Withholding Start Date' },
                    { key: 'withholding_tax_type_2', label: 'Withholding Tax Type 2' },
                    // withholding_tax_code_2 is NOT included
                    { key: 'withholding_tax_identification_number_2', label: 'Withholding Tax Identification Number 2' },
                    { key: 'withholding_agent_2', label: 'Withholding Agent 2' },
                    { key: 'withholding_start_date_2', label: 'Withholding Start Date 2' },
                    { key: 'tax_type_3', label: 'Tax Type 3' },
                    { key: 'price_list', label: 'Price List' },
                    { key: 'customer_group', label: 'Customer Group' },
                  );
                }

      
        // Collect missing fields
        const missingFields2 = mandatoryFields.filter(field => !formValues[field.key]?.trim());
if (missingFields2.length > 0) {
      setIsActive(false);
      const fieldNames = missingFields2.map(field => field.label).join(', ');
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(`Please fill the following required fields: ${fieldNames}`, {
          className: 'small-toast'
        });
      }
      return; // Stop function if validation fails
    }
        
        
        // if (godownAreaFilled) {
        //   if(!godownUnitFilled){
        //     if (!toast.isActive(toastId.current)) {
        //         toastId.current = toast.warning(`Please select the unit for godown area`, {
        //           className: "small-toast"
        //         });
        //       }
        //   }

        //   return;
        // }
        // let hasError = false;
        // let updatedValues = { ...formValues };
        // let missingFields = [];
        
    //     requiredFields.forEach((key) => {
    //         const value = updatedValues[key];
    
    //   if (typeof value === 'string') {
    //     if (value.trim() === '') {
    //       hasError = true;
    //       missingFields.push(key.replace(/_/g, ' '));
    //     } else {
    //       updatedValues[key] = value.trim();
    //     }
    //   } else if (value === undefined || value === null) {
    //     hasError = true;
    //     missingFields.push(key.replace(/_/g, ' '));
    //   }
    // });
    

    // setFormValues(updatedValues); 
    //  if (hasError) {
    //       console.log("cannot submit, fill mandatory")
    //       if (!toast.isActive(toastId.current)) {
    //         toastId.current = toast.warning(`Please fill all required fields: ${missingFields}`, {
    //           className: "small-toast"
    //         });
    //       }
          
    //       setIsActive(false);
          
    //       return;
    //     }

        console.log("here is the final form>> ", formValues)
        // localStorage.setItem("customerForm", JSON.stringify(formValues))
        // localStorage.setItem("customerForm2", JSON.stringify(formValues))
        // localStorage.setItem("filledForm2", JSON.stringify(formValues))
        // alert("Registration sucessful");
        // navigate("/customer/registration-form-2")



        try{
          const response= await updateCustomerMDM(formValues);
          const res= response.data;
          console.log("here is response>> ", res);
          if(res.status){
            if (!toast.isActive(toastId.current)) {
              toastId.current = toast.success(res.message, {
                className: "small-toast"
              });
            }
            setIsActive(false)
            console.log("success in submitting>> ", res)
            setOpenComment(true)
          }else{
            if (!toast.isActive(toastId.current)) {
              toastId.current = toast.warning(res.message, {
                className: "small-toast"
              });
            }
            setIsActive(false)
            console.log("not success in submitting>> ", res)
          }
        }catch(error){
          console.log("Error saving customer details>> ", error);
           if (!toast.isActive(toastId.current)) {
                  toastId.current = toast.error(error.message, {
                    className: "small-toast"
                  });
                }
                setIsActive(false)
        }
      }

       const saveApproval=async()=>{
          setIsActive(true)
          const body={
            "reference_id": formValues.reference_id,
          "approved_by":userID,
          }
          console.log("approval body>>> ", body)
          try{
            const response= await syncCustomerMDM(body);
            const res= response.data;
            if(res.status){
              console.log("customer approved success", res);
              setIsActive(false)
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.success(res.message,{
                  className:"small-toast"
                })
              }
            //   setOpenApproverDialog(false);
            //   setOpenDialog(false);
              setOpenComment(false)
              navigate("/customers-list")
            //   fetchCustomers();
            }else{
                if(!toast.isActive(toastId.current)){
                  toastId.current= toast.warning(res.message,{
                    className:"small-toast"
                  })
                }
              setIsActive(false)
              console.log("could not approve>> ", res)
            }
          }catch(error){
            setIsActive(false)
            console.log("error in approving>> ", error)
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.error(error.message,{
                className:"small-toast"
              })
            }
            if(error.response?.status==403){
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error("Your Session has expired",{
                  className:"small-toast"
                })
              }
              setTimeout(()=>{
                navigate("/")
                localStorage.clear();
              },2000)
              return;
            }
          }
        }

    return(

    <DashboardLayout>
        <DashboardNavbar/>

     
     <Grid>
      <SimpleBackdrop openLoader={isActive}/>
      <ToastContainer/>

    
        
        <SoftBox className="bp formBG">
          <form noValidate onSubmit={handleSubmitForm}>
         <SoftBox py={3} className="customerblock">
           <Grid container spacing={3}>
             <Grid item xs={12} lg={12}>
               <Card sx={{ overflow: "visible" }}>
                 <SoftBox p={3}>
                   <SoftTypography variant="h5" id="form_heading textUppercase">Customer Details</SoftTypography>

                   

                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Name of Firm (in block letters)*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="firm_name"
                             id="firm_name"
                            //  error={formValues.firm_name.error} 
                             value={formValues.firm_name}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('firm_name', wordCapital)}}
                             
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Status of Firm*
                             </SoftTypography>
                           </SoftBox>
                            <SoftSelect
                                                        name="firm_status"
                                                        id="address"
                                                       options={custTitle}
                                                       value={[
                                                         { value: formValues.firm_status, label:titleName!==""? titleName: formValues.firm_status} // Set the selected state value here
                                                       ]}
                                                        onChange={(e) =>{
                                                         setTitleName(e.label)
                                                         handleFormChange('firm_status', e.value)}}
                                                        
                                                      />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Street*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="street"
                             id="street"
                            inputProps={{maxLength: 60}}
                            //  value={formValues.office_address?.value || ''}
                             value={formValues.street}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('street', wordCapital)}}
                           onKeyDown={(e)=>{
                                                         if(e.target.value.length==60){
                                                            if (!toast.isActive(toastId.current)) {
                                     toastId.current = toast.warning("Street  Cannot be more than 60 digits", {
                                       className: "small-toast"
                                     });
                                   }
                                                         }
                                                       }}
                           />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               PO Box
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="po_box"
                             id="po_box"
                           
                            //  value={formValues.office_address?.value || ''}
                             value={formValues.po_box}
                             onChange={(e) => handleFormChange('po_box', e.target.value)}
                           
                           />
                         </SoftBox>
                       </Grid>
                     </Grid>
                   </SoftBox>

                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              State Name*
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             
                             id="state"
                             options = {customerState}
                              value={[
                                { value: formValues.state, label: formValues.state } // Set the selected state value here
                              ]}
                             onChange={(e) => handleFormChange('state', e.value)}
                             size="medium"
                            
                              />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Pin Code*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="pin_code"
                             name="pin_code"
                            
                             value={formValues.pin_code}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('pin_code', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                                                          if(e.target.value.length==5){
                                                             if (!toast.isActive(toastId.current)) {
                                      toastId.current = toast.warning("Pin code Cannot be more than 6 characters", {
                                        className: "small-toast"
                                      });
                                    }
                                                          }
                                                        }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               City*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="city"
                             id="city"
                             value={formValues.city}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('city', wordCapital)}}
                           />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               District Name*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                                                        name="district_name"
                                                        id="district_name"
                                                        readOnly
                                                        value={formValues.district_name}
                                                        onClick={(e) =>{
                                                         setSelectedKeyName("zzdist");
                                                         let filteredData = zData
                                                         .map(item => item.zzdist)
                                                         .filter(value => value && value.trim() !== '');
                                                         setFilteredZone(filteredData)
                                                         setDialogOpen2(true)
                           
                                                         setSelectedZoneName('district_name');
                                                        }}
                                                      />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Block/Tehsil/Taluka/Mandal Name
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="block_tehsil"
                             
                             value={formValues.block_tehsil}
                             onChange={(e) => handleFormChange('block_tehsil', e.target.value)}
                             size="medium" />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                       <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Main Town/Village Name
                             </SoftTypography>
                           </SoftBox>
                          <SoftInput
                                                       name="main_town_village"
                                                       id="main_town_village"
                                                      
                                                      value={formValues.main_town_village}
                                                      onClick={(e) =>{
                                                        let filteredData = zData
                                                        .map(item => item.zztown)
                                                        .filter(value => value && value.trim() !== '');
                                                        setFilteredZone(filteredData)
                                                        setDialogOpen2(true)
                          
                                                        setSelectedZoneName('main_town_village');
                                                       }}
                                                       
                                                     />
                       </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                       <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                             
                             >
                               Post office
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="post_office"
                             
                             value={formValues.post_office}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('post_office', wordCapital)}}
                             size="medium"
                              />
                       </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Police Station
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="police_station"
                             name="police_station"
                            //  error={formValues.police_station.error}
                             value={formValues.police_station}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('police_station', wordCapital)}}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       {/* <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               disabled
                             >
                               Mobile*.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="mobile"
                             name="mobile"
                             inputProps={{maxLength:10}}
                             value={formValues.mobile}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('mobile', onlyNumbers);
                            }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Email*.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="email"
                             name="email"
                              
                             value={formValues.email}
                             onChange={(e) => handleFormChange('email', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid> */}

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Name of Proprietor / Partners / Directors*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="proprietor_name"
                             name="proprietor_name"
                            
                             value={formValues.proprietor_name}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('proprietor_name', wordCapital)}}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Proprietor Contact No:-(WhatsApp No.)*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="proprietor_mobile"
                             name="proprietor_mobile"
                             inputProps={{ maxLength: 10 }}
                             value={formValues.proprietor_mobile}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('proprietor_mobile', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                                                          if(e.target.value.length==10){
                                                             if (!toast.isActive(toastId.current)) {
                                      toastId.current = toast.warning("Mobile No Cannot be more than 10 digits", {
                                        className: "small-toast"
                                      });
                                    }
                                                          }
                                                        }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                             
                             >
                              Proprieter Email Id*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="proprietor_email"
                             name="proprietor_email"
                            
                             value={formValues.proprietor_email}    
                             onChange={(e) => handleFormChange('proprietor_email', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>


                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Date of Birth of Proprietor/Partner/Director*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="date"
                             id="proprietor_dob"
                             name="proprietor_dob"
                            
                             value={formatDate(formValues.proprietor_dob)}
                             onChange={(e) => {
                                                           const selectedDate = new Date(e.target.value);
                                                           const today = new Date();
                                                         
                                                           if (selectedDate > today) {
                                                             if (!toast.isActive(toastId.current)) {
                                                               toastId.current = toast.warning("DOB cannot be a future date", {
                                                                 className: "small-toast",
                                                               });
                                                             }
                                                             handleFormChange('proprietor_dob', '');
                                                             return; // don't update the state if it's an invalid future date
                                                           }
                                                         
                                                           const day = String(selectedDate.getDate()).padStart(2, '0');
                                                           const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
                                                           const year = selectedDate.getFullYear();
                                                         
                                                           const formattedDate = `${year}${month}${day}`;
                                                           handleFormChange('proprietor_dob', formattedDate);
                                                         }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Name of Contact Person*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="contact_person"
                             name="contact_person"
                            
                             value={formValues.contact_person}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('contact_person', wordCapital)}}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Contact Person Telephone.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="contact_person_telephone"
                             name="contact_person_telephone"
                             inputProps={{ maxLength: 11 }}
                             value={formValues.contact_person_telephone}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('contact_person_telephone', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                                                          if(e.target.value.length==11){
                                                             if (!toast.isActive(toastId.current)) {
                                      toastId.current = toast.warning("Telephone No Cannot be more than 11 digits", {
                                        className: "small-toast"
                                      });
                                    }
                                                          }
                                                        }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Contact Person Mobile*.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="mobile"
                             name="mobile"
                             inputProps={{ maxLength: 10 }}
                             value={formValues.contact_person_mobile}
                             oonChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('contact_person_mobile', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                                                          if(e.target.value.length==10){
                                                             if (!toast.isActive(toastId.current)) {
                                      toastId.current = toast.warning("Mobile No Cannot be more than 10 digits", {
                                        className: "small-toast"
                                      });
                                    }
                                                          }
                                                        }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Contact Person Email*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="contact_person_email"
                             name="contact_person_email"
                            
                             value={formValues.contact_person_email}
                             onChange={(e) => handleFormChange('contact_person_email', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                      
                       
                     </Grid>
                   </SoftBox>


                 
                   

                   

                 </SoftBox>
               </Card>
             </Grid>
           </Grid>
         </SoftBox>

         <SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
     <SoftTypography variant="h5" id="form_heading">Business Details</SoftTypography>


       <SoftBox mt={1}>
         <Grid container spacing={3}>
         <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               GSTIN No*.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="gstn"
                             name="gstn"
                            error={panGSTError2}
                             value={formValues.gstn}
                             size="medium"
                           onChange={(e) => {
                                                                                     const gstn = e.target.value.trim();
                                                                                   
                                                                                     if (gstn === "") {
                                                                                       setFormValues((prev) => ({
                                                                                         ...prev,
                                                                                         gstn: "",
                                                                                         pan: "",
                                                                                       }));
                                                                                       return;
                                                                                     }
                                                                                   
                                                                                     const gstnRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
                                                                                   
                                                                                     if (gstnRegex.test(gstn)) {
                                                                                       const panFromGstn = gstn.substring(2, 12); // Extract PAN
                                                                                       console.log("pan is>> ", panFromGstn);
                                                                                       setFormValues((prev) => ({
                                                                                         ...prev,
                                                                                         gstn: gstn,
                                                                                         pan: panFromGstn,
                                                                                       }));
                                                                                       setPanGSTError2(false)
                                                                                     } else {
                                                                                       if (!toast.isActive(toastId.current)) {
                                                                                         toastId.current = toast.warning("Please fill a valid GSTIN number", {
                                                                                           className: "small-toast",
                                                                                         });
                                                                                      
                                                                                       }
                                                                                       setPanGSTError2(true)
                                                                                       setFormValues((prev) => ({
                                                                                         ...prev,
                                                                                         gstn: gstn,
                                                                                         pan: "", // Clear PAN if GSTN is invalid
                                                                                       }));
                                                                                     }
                                                                                   }}
                             
                             />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               PAN number*.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="pan"
                             name="pan"
                            error={panGSTError}
                             value={formValues.pan}
                              onChange={(e) => {
                                                                                        const pan = e.target.value.trim().toUpperCase();
                                                                                        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                                                                                      
                                                                                        if (pan === "") {
                                                                                          handleFormChange('pan', pan);
                                                                                          return;
                                                                                        }
                                                                                      
                                                                                        if (panRegex.test(pan)) {
                                                                                          setFormValues((prev) => ({
                                                                                            ...prev,
                                                                                            pan: pan,
                                                                                          }));
                                                                                          setPanGSTError(false)
                                                                                        } else {
                                                                                          if (!toast.isActive(toastId.current)) {
                                                                                            toastId.current = toast.warning("Please enter a valid PAN number", {
                                                                                              className: "small-toast",
                                                                                            });
                                                                                          }
                                                                                          setPanGSTError(true)
                                                                                          setFormValues((prev) => ({
                                                                                            ...prev,
                                                                                            pan: pan,
                                                                                          }));
                                                                                        }
                                                                                      }}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               FSSAI No.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="fssi_regn_no"
                             name="fssi_regn_no"
                            
                             value={formValues.fssi_regn_no}
                             onChange={(e) => handleFormChange('fssi_regn_no', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                     

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Aadhaar (mandatory for proprietership firm).
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="aadhaar"
                             name="aadhaar"
                            
                             value={formValues.aadhaar}    
                             onChange={(e) => handleFormChange('aadhaar', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               TAN number.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="tan"
                             name="tan"
                            
                             value={formValues.tan}
                             onChange={(e) => handleFormChange('tan', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>


                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               CIN ( applicable for  LTD / PVT / LLP) .
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="cin"
                             name="cin"
                            
                             value={formValues.cin}
                             onChange={(e) => handleFormChange('cin', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               ROC status of company whether exist of strike of
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             type="text"
                             id="pan"
                             name="roc_status"
                            value={[
                                {value: formValues.roc_status, label: formValues.roc_status } // Set the selected state value here
                            ]}
                            //  value={formValues.roc_status.value}
                             onChange={(e) => handleFormChange('roc_status', e.value)}
                             size="medium"
                             options={[
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"}
                             ]}
                             />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Investment Amount Plan for Anmol(Rs.)
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="inpln"
                             name="inpln"
                            
                             value={formValues.inpln}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('inpln', onlyNumbers);
                            }}
                             size="medium"
                             />
                         </SoftBox>
                       </Grid>

                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Non-IT Return 
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             id="inpln"
                             name="inpln"
                            
                             value={[
                              {value: formValues.non_it_return, label: formValues.non_it_return } // Set the selected state value here
                             ]}
                             options={[
                              {value:"Yes", label:"Yes"},
                              {value:"No", label:"No"}
                             ]}
                             onChange={(e) => handleFormChange('non_it_return', e.value)}
                             size="medium"
                             />
                         </SoftBox>
                       </Grid> */}
                       


         </Grid>
       </SoftBox>

     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

<SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
     <SoftTypography variant="h5" id="form_heading">Bank Details</SoftTypography>


       <SoftBox mt={1}>
         <Grid container spacing={3}>
         <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Bank Account No.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                                                        type="text"
                                                        id="bank_account_number"
                                                        name="bank_account_number"
                                                       inputProps={{maxLength:20}}
                                                        value={formValues.bank_account_number}
                                                        onChange={(e) => {
                                                         const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                                         handleFormChange('bank_account_number', onlyNumbers);}}
                                                        size="medium"
                                                        onKeyDown={(e)=>{
                                                                                      if(e.target.value.length==20){
                                                                                         if (!toast.isActive(toastId.current)) {
                                                                  toastId.current = toast.warning("Account No Cannot be more than 20 digits", {
                                                                    className: "small-toast"
                                                                  });
                                                                }
                                                                                      }
                                                                                    }}
                                                        />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               IFSC Code.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="ifsc_code"
                             name="ifsc_code"
                            
                             value={formValues.ifsc_code}
                             onChange={(e) => handleFormChange('ifsc_code', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Bank Name.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_name"
                             name="bank_name"
                            
                             value={formValues.bank_name}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('bank_name', wordCapital)}}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Bank Branch Name.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_branch_name"
                             name="bank_branch_name"
                            
                             value={formValues.bank_branch_name}
                             onChange={(e) => handleFormChange('bank_branch_name', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Undated Cheque No. 1.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_branch_name"
                             name="bank_branch_name"
                            
                             value={formValues.undated_cheque_1}
                             onChange={(e) => handleFormChange('undated_cheque_1', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Undated Cheque No. 2.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_branch_name"
                             name="bank_branch_name"
                            
                             value={formValues.undated_cheque_2}
                             onChange={(e) => handleFormChange('undated_cheque_2', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Undated Cheque No. 3.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_branch_name"
                             name="bank_branch_name"
                            
                             value={formValues.undated_cheque_3}
                             onChange={(e) => handleFormChange('undated_cheque_3', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Miscellaneous.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_branch_name"
                             name="bank_branch_name"
                            
                             value={formValues.miscellaneous}
                             onChange={(e) => handleFormChange('miscellaneous', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>

         </Grid>
       </SoftBox>

     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

<SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
     <SoftTypography variant="h5" id="form_heading" style={{marginBottom:'8px'}}>Other Information & Infastructure Details</SoftTypography>
     <SoftTypography variant="p" >Other Products details in which the Customer is dealing with, if any</SoftTypography>
     <SoftBox mt={1}>
     {formValues.companies.map((company, index) => (
      <div style={{borderBottom: "1px dashed rgb(233, 233, 233)", paddingBottom: "16px"}} key={index}>
     <Grid container spacing={3} key={index}>
    <React.Fragment key={index} >      
      <Grid item xs={12} sm={4}>
        <SoftBox >
          <SoftTypography variant="caption" fontWeight="bold">Name of the Company</SoftTypography>
          <SoftInput
            type="text"
            value={company.name_of_company}
            onChange={(e) => handleFormChange('name_of_company', e.target.value, index)}
          />
        </SoftBox>
      </Grid>
      <Grid item xs={12} sm={4}>
        <SoftBox >
          <SoftTypography variant="caption" fontWeight="bold">Brand</SoftTypography>
          <SoftInput
            type="text"
            value={company.company_brand}
            onChange={(e) => handleFormChange('company_brand', e.target.value, index)}
          />
        </SoftBox>
      </Grid>
      <Grid item xs={12} sm={4}>
        <SoftBox>
          <SoftTypography variant="caption" fontWeight="bold">Monthly Turnover</SoftTypography>
          <SoftInput
            type="text"
            inputProps={{maxLength: 8}}
            value={company.monthly_turnover}
            onChange={(e) => handleFormChange('monthly_turnover', e.target.value, index)}
          />
        </SoftBox>
      </Grid>
    </React.Fragment>
    </Grid>
    </div>
  ))}



{/* <Grid container spacing={1}>
  <Grid item xs={6} sm={4}>
    <SoftButton variant="contained" color="info"  onClick={addRow}>
      Add Row
    </SoftButton>
  </Grid>
  {formValues.companies.length > 1 && (
    <Grid item xs={6} sm={4}>
      <SoftButton variant="contained" color="error"  onClick={() => removeRow(formValues.companies.length - 1)}>
        Remove
      </SoftButton>
    </Grid>
  )}
</Grid> */}

<SoftBox mt={2} style={{display: "flex", justifyContent: "flex-end"}}>
<SoftButton variant="contained" color="info"  onClick={addRow}>
      Add Row
    </SoftButton>
          {formValues.companies.length > 1 && (
           
           <SoftButton variant="contained" style={{marginLeft:'12px'}} color="error"  onClick={() => removeRow(formValues.companies.length - 1)}>
           <DeleteIcon/>
         </SoftButton>
           
          )}
          </SoftBox>
     </SoftBox>
      
     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

<SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
<Grid item xs={12} lg={12}>
<Card sx={{ overflow: "visible" }}>
<SoftBox p={3}>
<SoftTypography variant="h5" id="form_heading">Storage details</SoftTypography>
<SoftBox mt={1}>
<Grid container spacing={3}>
<Grid item xs={12} sm={4}>
  <SoftBox mb={3}>
    <SoftTypography variant="caption" fontWeight="bold">
      Godown Area (sqft)
    </SoftTypography>
    <Box display="flex" alignItems="center" gap={1}>
      <SoftInput
        type="text"
        value={formValues.godown_area.split(" ")[0]}
        onChange={(e) => handleFormChange('godown_area', e.target.value)}
        sx={{ width: '70%' }} // adjust main input width
      />
      <TextField
        variant="outlined"
        size="small"
        placeholder="Unit"
        value={godownUnit}
        onClick={(e)=> setDialogOpen(true)}
        sx={{ width: '30%' }} // size of the extra box
      />
    </Box>
  </SoftBox>
</Grid>

      <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">Godown Type</SoftTypography>
          <SoftInput
        type="text"
        value={formValues.godown_type}
        onChange={(e) => handleFormChange('godown_type', e.target.value)}
        
      />
        </SoftBox>
      </Grid>
      <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">RCC Structure</SoftTypography>
          <SoftInput
        type="text"
        value={formValues.rcc_structure}
        onChange={(e) => handleFormChange('rcc_structure', e.target.value)}
        
      />
        </SoftBox>
      </Grid>
      <Grid item xs={12} sm={4}>
  <SoftBox mb={3}>
    <SoftTypography variant="caption" fontWeight="bold">Delivery Vehicle Type</SoftTypography>
    <FormGroup sx={{displaye:'flex', justifyContent:'space-between'}}>
      <FormControlLabel
        control={
          <Checkbox
          size="small"
            checked={formValues.del_type_rickshaw === "X"}
            onChange={(e) =>
              handleFormChange('del_type_rickshaw', e.target.checked ? "X" : "")
            }
          />
        }
        label={
          <SoftTypography variant="caption">Rickshaw</SoftTypography>
        }
      />
      <FormControlLabel
        control={
          <Checkbox
          size="small"
            checked={formValues.del_type_van === "X"}
            onChange={(e) =>
              handleFormChange('del_type_van', e.target.checked ? "X" : "")
            }
          />
        }
        label={
          <SoftTypography variant="caption">Auto Van</SoftTypography>
        }
      />
    </FormGroup>
  </SoftBox>
</Grid>

{formValues.del_type_van === "X" && (
  <Grid item xs={12} sm={4}>
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold">Auto Van Model</SoftTypography>
      <SoftInput
        type="text"
        value={formValues.model_no_van || ""}
        onChange={(e) => handleFormChange("model_no_van", e.target.value)}
      />
    </SoftBox>
  </Grid>
)}

<Grid container spacing={2} justifyContent="flex-start" style={{ marginLeft: '1%' }}>
  <Grid item xs={10} sm={3}>
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold">Salesman 1</SoftTypography>
      <SoftInput
        type="text"
        value={formValues.customer_salesman_1}
        onChange={(e) => {
          let wordCapital= capitalizeInitials(e.target.value)
          handleFormChange('customer_salesman_1', wordCapital)}}
      />
    </SoftBox>
  </Grid>
  
  <Grid item xs={12} sm={3}>
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold">Mobile 1</SoftTypography>
      <SoftInput
        type="text"
        inputProps={{maxLength:10}}
        value={formValues.customer_salesman_no_1}
        onChange={(e) => {
          const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
          handleFormChange('customer_salesman_no_1', onlyNumbers);
        }}
      />
    </SoftBox>
  </Grid>

  <Grid item xs={12} sm={3}>
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold">Salesman 2</SoftTypography>
      <SoftInput
        type="text"
        value={formValues.customer_salesman_2}
        onChange={(e) => {
          let wordCapital= capitalizeInitials(e.target.value)
          handleFormChange('customer_salesman_2', wordCapital)}}
      />
    </SoftBox>
  </Grid>

  <Grid item xs={12} sm={3}>
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold">Mobile 2</SoftTypography>
      <SoftInput
        type="text"
        value={formValues.customer_salesman_no_2}
        inputProps={{maxLength:10}}
        onChange={(e) => {
          const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
          handleFormChange('customer_salesman_no_2', onlyNumbers);
        }}
      />
    </SoftBox>
  </Grid>
</Grid>

      <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">Week Off Day Followed by Customer.</SoftTypography>
          <SoftInput
            type="text"
           value={formValues.customer_weekoff}
            onChange={(e) => handleFormChange( 'customer_weekoff', e.target.value)}
          />
        </SoftBox>
      </Grid>
</Grid>
</SoftBox>
</SoftBox>
</Card>
</Grid>
</Grid>
</SoftBox>

{customerType!=="railway_distributor" && customerType!=="super_stockist" && 

<SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
<Grid item xs={12} lg={12}>
<Card sx={{ overflow: "visible" }}>
<SoftBox p={3}>
<SoftTypography variant="h5" id="form_heading">Market Details</SoftTypography>

<Grid container spacing={3} >
  {Object.keys(formValues.marketDetails).map((day) => (
    <Grid item xs={12} key={day} style={{paddingTop: "0px", marginTop: "15px"}}>
      <Card sx={{ overflow: "hidden" }}>
        <SoftBox p={0}>
        <SoftTypography
        variant="h6"
        component="label"
        fontWeight="bold"
        
        style={{padding: "10px", marginBottom:"8px", backgroundColor:'#ccc', }}>{day}</SoftTypography>
          {formValues.marketDetails[day].map((row, index) => {
          
            return(
<>
            <Grid container spacing={1} key={index} style={{padding: "20px 20px", borderBottom: "1px dashed #ccc", position:'relative', display:'flex',flexWrap: 'nowrap', overflowX: 'auto'}}>
             
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Beat Name</SoftTypography>
                <SoftInput
                type="text"
                  value={row.beatName_1}
                  onChange={(e) => handleFormChange("beatName_1", e.target.value, index, day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold" whiteSpace="noWrap">Distance from Godown</SoftTypography>
                <SoftInput
                  type="number"
                  inputProps={{ step: "0.01", min:0 }}
                  value={row.distanceFromGodown_1}
                  onChange={(e) => handleFormChange("distanceFromGodown_1", e.target.value, index, day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Expected Daily Sales</SoftTypography>
                <SoftInput
                 type="number"
                 inputProps={{ step: "0.01" }}
                 value={row.expectedDailySales_1}
                  onChange={(e) => handleFormChange("expectedDailySales_1", e.target.value, index,day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Retailer</SoftTypography>
                <SoftInput
                 type="number"
                value={row.retailer_1}
                  onChange={(e) => handleFormChange("retailer_1", e.target.value, index,day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Wholesaler</SoftTypography>
                <SoftInput
                  type="number"
                  value={row.wholesaler_1}
                  onChange={(e) => handleFormChange("wholesaler_1", e.target.value, index, day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold" whiteSpace="noWrap">Frequency of Visit (Weekly)</SoftTypography>
                <SoftInput
                 type="text"
                 value={row.frequencyOfVisit_1}
                  onChange={(e) => handleFormChange("frequencyOfVisit_1", e.target.value, index, day)}
                  size="medium"
                />
              </Grid>
              <Grid item xs={2}>
              <SoftTypography variant="caption" fontSize="10px" fontWeight="bold" whiteSpace="noWrap">Ready Stock or Order booking</SoftTypography>
                <SoftInput
                  type="text"
                 value={row.readyStockOrOrderBooking_1}
                  onChange={(e) => handleFormChange("readyStockOrOrderBooking_1", e.target.value, index, day)}
                  size="medium"
                />
              </Grid>
              {/* {formValues.marketDetails[day].length > 1 && index!==0 && (
                 <div style={{width: "30px", height: "30px", backgroundColor: "#efefef", position:'absolute', right:'10px', cursor:'pointer', 
                 top:'25px', borderRadius:'50%', display:'flex', justifyContent:'center', alignItems:'center'}} onClick={() => removeRowMarket(day, index)}>
                 <CloseIcon/>
               </div>
                // <Grid item xs={2}>
                //   <SoftButton variant="contained" color="error" onClick={() => removeRowMarket(day, index)}>
                //     <DeleteIcon/>
                //   </SoftButton>
                // </Grid>
              )} */}
            </Grid>

            <Grid container spacing={1} key={index} style={{padding: "20px 20px", borderBottom: "1px dashed #ccc", position:'relative',display:'flex',flexWrap: 'nowrap', overflowX: 'auto'}}>
             
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Beat Name</SoftTypography>
               <SoftInput
               type="text"
                 value={row.beatName_2}
                 onChange={(e) => handleFormChange("beatName_2", e.target.value, index, day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold" whiteSpace="noWrap">Distance from Godown</SoftTypography>
               <SoftInput
                 type="number"
                 inputProps={{ step: "0.01", min: 0 }}
                 value={row.distanceFromGodown_2}
                 onChange={(e) => handleFormChange("distanceFromGodown_2", e.target.value, index, day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Expected Daily Sales</SoftTypography>
               <SoftInput
                 type="number"
                 inputProps={{ step: "0.01" }}
                value={row.expectedDailySales_2}
                 onChange={(e) => handleFormChange("expectedDailySales_2", e.target.value, index,day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Retailer</SoftTypography>
               <SoftInput
                type="number"
               value={row.retailer_2} 
                 onChange={(e) => handleFormChange("retailer_2", e.target.value, index,day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Wholesaler</SoftTypography>
               <SoftInput
                 type="number"
                 value={row.wholesaler_2}
                 onChange={(e) => handleFormChange("wholesaler_2", e.target.value, index, day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold" whiteSpace="noWrap">Frequency of Visit (Weekly)</SoftTypography>
               <SoftInput
                type="text"
                value={row.frequencyOfVisit_2}
                 onChange={(e) => handleFormChange("frequencyOfVisit_2", e.target.value, index, day)}
                 size="medium"
               />
             </Grid>
             <Grid item xs={2}>
             <SoftTypography variant="caption" fontSize="10px" fontWeight="bold" whiteSpace="noWrap">Ready Stock or Order booking</SoftTypography>
               <SoftInput
                 type="text"
                value={row.readyStockOrOrderBooking_2}
                 onChange={(e) => handleFormChange("readyStockOrOrderBooking_2", e.target.value, index, day)}
                 size="medium"
               />
             </Grid>
             {/* {formValues.marketDetails[day].length > 1 && index!==0 && (
                <div style={{width: "30px", height: "30px", backgroundColor: "#efefef", position:'absolute', right:'10px', cursor:'pointer', 
                top:'25px', borderRadius:'50%', display:'flex', justifyContent:'center', alignItems:'center'}} onClick={() => removeRowMarket(day, index)}>
                <CloseIcon/>
              </div>
               // <Grid item xs={2}>
               //   <SoftButton variant="contained" color="error" onClick={() => removeRowMarket(day, index)}>
               //     <DeleteIcon/>
               //   </SoftButton>
               // </Grid>
             )} */}
           </Grid>
</>

            
            )
         })}
          {/* <SoftBox  p={2}>
            <SoftButton variant="contained" color="info" onClick={() => addRowMarket(day)}>
              Add Row
            </SoftButton>
          </SoftBox> */}
        </SoftBox>
      </Card>
    </Grid>
  ))}
</Grid>


</SoftBox>
</Card>
</Grid>
</Grid>
</SoftBox>
}


<SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
<Grid item xs={12} lg={12}>
<Card sx={{ overflow: "visible" }}>
<SoftBox p={3}>
<SoftTypography variant="h5" id="form_heading">ASM Details</SoftTypography>
<SoftBox mt={1}>
<Grid container spacing={3}>
<Grid item xs={12} sm={4}>
{(saveForm.sap_code==null || saveForm.sap_code=="") &&
<>
  <SoftBox mb={3}>
    <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
        Registration Type
      </SoftTypography>
    </SoftBox>
    <SoftBox display="flex" flexDirection="row" height="40px" gap={3}>
      {/* <label>
        <input  type="checkbox"
          name="registration_type"
          value="Existing"
          checked={formValues.registration_type === "Existing"}
          onChange={(e) => handleFormChange2("registration_type", e.target.value)} />
        Existing
      </label> */}
      <label>
        <input  type="checkbox"
          name="registration_type"
          value="New"
          checked={formValues.registration_type === "New"}
          onChange={(e) => handleFormChange2("registration_type", e.target.value)} style={{fontSize:'12px'}} />
        New
      </label>
      <label>
        <input type="checkbox"
          name="registration_type"
          value="Replacement"
          checked={formValues.registration_type === "Replacement"}
          onChange={(e) => handleFormChange2("registration_type", e.target.value)} />
        Replacement
      </label>
  </SoftBox>
</>
}
</Grid>


<Grid item xs={12} sm={4}>
<SoftBox mb={3}>
    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
      <SoftTypography
        component="label"
        variant="caption"
        fontWeight="bold"
        textTransform="capitalize"
      >
       Concern Super Stockist (In case of Sub DB) {formValues.customer_type=="Sub Distributor" && <span>*</span>}
      </SoftTypography>
    </SoftBox>
    <SoftInput
    type="text"
      name="sap_code"
      id="sap_code"
     //  error={formValues.tds_nature_of_service.error}
      value={formValues.concern_super_stockist}
      onBlur={fetchCustomerBySapCode}
      onChange={(e) =>{
        setStockistCode(e.target.value)
        handleFormChange2('concern_super_stockist',e.target.value)
      }}
    />
  </SoftBox>
</Grid>

{((saveForm.sapCode!==null || saveForm.sap_code!=="")|| formValues.registration_type=== "Replacement")&&
<>
<Grid item xs={12} sm={4}>
<SoftBox mb={3}>
    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
      <SoftTypography
        component="label"
        variant="caption"
        fontWeight="bold"
        textTransform="capitalize"
      >
       Associated to SAP Code
      </SoftTypography>
    </SoftBox>
    <SoftInput
    type="text"
      name="sap_code"
      id="sap_code"
     //  error={formValues.tds_nature_of_service.error}
      value={formValues.associated_to_sap_code}
      onChange={(e) => handleFormChange2('associated_to_sap_code', e.target.value)}
    />
  </SoftBox>
</Grid>
<Grid item xs={12} sm={4}>
  <SoftBox mb={3} id="name3">
    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
      <SoftTypography
        component="label"
        variant="caption"
        fontWeight="bold"
        textTransform="capitalize"
      >
       Associated to SAP Name
      </SoftTypography>
    </SoftBox>
    <SoftInput
    type="text"
      name="sap_name"
      id="sap_name"
     //  error={formValues.tds_section.error}
      value={formValues.associated_to_sap_name}
      onChange={(e) => handleFormChange2('associated_to_sap_name', e.target.value)}
    />
  </SoftBox>
</Grid>
</>
}

        <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="name3">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     textTransform="capitalize"
                                   >
                                    Sub Town/ Village Name
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                 type="text"
                                   name="sub_town"
                                   id="sub_town"
                                  //  error={formValues.tds_section.error}
                                   value={formValues.sub_town_village_name}
                                   onChange={(e) => handleFormChange2('sub_town_village_name', e.target.value)}
                                 />
                               </SoftBox>
                             </Grid>
      <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="name3">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     textTransform="capitalize"
                                   >
                                    Working Town/Village
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                 type="text"
                                   name="work_town"
                                   id="work_town"
                                  //  error={formValues.tds_section.error}
                                   value={formValues.working_town_village_name}
                                   onChange={(e) => handleFormChange2('working_town_village_name', e.target.value)}
                                 />
                               </SoftBox>
                             </Grid>

 <Grid item xs={12} sm={4}>
                          <SoftBox mb={2}>
                          <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                         <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
                           Party Type
                         </SoftTypography>
                       </SoftBox>
                       <SoftBox display="flex" flexDirection="row" height="40px" gap={3}>
                         <label>
                           <input type="checkbox"
      name="party_type"
      value="Group A"
      checked={formValues.party_type === "Group A"}
      onChange={(e) => handleFormChange2("party_type", e.target.value)} />
                           Group A
                         </label>
                         <label>
                           <input type="checkbox"
      name="party_type"
      value="Group B"
      checked={formValues.party_type === "Group B"}
      onChange={(e) => handleFormChange2("party_type", e.target.value)} />
                           Group B
                         </label>
                         <label>
                           <input type="checkbox"
      name="party_type"
      value="All Group"
      checked={formValues.party_type === "All Group"}
      onChange={(e) => handleFormChange2("party_type", e.target.value)} />
                           All Group
                         </label>
                       </SoftBox>
                          </SoftBox>
                        </Grid> 

<Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Date of Association (If Existing Party)
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="date"
                             name="date_of_association"
                             id="date_of_association"
                            //  error={formValues.tds_section.error}
                             value={formatDate(formValues.date_of_association)}
                             onChange={(e) => {
                              const dateObj = new Date(e.target.value);
                              const day = String(dateObj.getDate()).padStart(2, '0');
                              const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                              const year = dateObj.getFullYear();
                              const formattedDate = `${year}${month}${day}`;
                              console.log("here is formattedDate>> ", formattedDate)  
                              handleFormChange2('date_of_association', formattedDate);
                            }}
                           />
                         </SoftBox>
                       </Grid>

      <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="name3">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     textTransform="capitalize"
                                   >
                                    Association (in no of years)
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                 type="text"
                                   name="association_years"
                                   id="association_years"
                                  //  error={formValues.tds_section.error}
                                   value={formValues.association_years}
                                   onChange={(e) => handleFormChange2('association_years', e.target.value)}
                                 />
                               </SoftBox>
                             </Grid>

                {formValues.area_alloted?.map((company, index) => (
                  <React.Fragment key={index}>
                    <Grid container spacing={2} sx={{marginLeft:'2%'}}>
                      <Grid item xs={12} sm={4}>
                        <SoftBox mb={3}>
                          <SoftTypography variant="caption" fontWeight="bold">Town/village/city name</SoftTypography>
                          <SoftInput
                            type="text"
                            value={company.town_name}
                            onChange={(e) => handleFormChange2('town_name', e.target.value, index)}
                          />
                        </SoftBox>
                      </Grid>
                
                      <Grid item xs={12} sm={4}>
                        <SoftBox mb={3}>
                          <SoftTypography variant="caption" fontWeight="bold">Population</SoftTypography>
                          <SoftInput
                            type="text"
                            value={company.population}
                            onChange={(e) => handleFormChange2('population', e.target.value, index)}
                          />
                        </SoftBox>
                      </Grid>
                
                      <Grid item xs={12} sm={4}>
                        <SoftBox mb={3}>
                          <SoftTypography variant="caption" fontWeight="bold">Distance From Godown</SoftTypography>
                          <SoftInput
                            type="number"
                            inputProps={{ min: 0 }}
                            value={company.distance_from_godown}
                            onChange={(e) => handleFormChange2('distance_from_godown', e.target.value, index)}
                          />
                        </SoftBox>
                      </Grid>
                    </Grid>
                
                    {formValues.area_alloted.length > 1 && (
                      <Grid item xs={12} sx={{marginLeft:'2%'}}>
                        <SoftButton 
                          variant="contained" 
                          color="error" 
                          onClick={() => removeRowArea(index)}
                        >
                          Remove
                        </SoftButton>
                      </Grid>
                    )}
                    
                    <Grid item xs={12} sx={{marginLeft:'2%'}}>
                      <SoftButton variant="contained" color="info" onClick={addRowArea}>Add Row</SoftButton>
                    </Grid>
                  </React.Fragment>
                ))}    

                <div className="p-4" style={{overflowX:"auto"}}>
 <table className="border-collapse border border-gray-400 w-full">
<thead>
 <tr>
<th className=" p-2">Target</th>
{months.map((month) => (
 <th key={month} className="border border-gray-400 p-2">{month}</th>
 ))}
 </tr>
</thead>
 <tbody>
 {formValues.targets?.map((target, targetIndex) => (
    <tr key={targetIndex}>
      <td className="border border-gray-400 p-2">{target.name}</td>
      {months.map((month, monthIndex) => (
        <td key={monthIndex} className="border border-gray-400 p-2">
          <input
            type="text"
            value={formValues.targets[targetIndex].months[month]}
            onChange={(e) => handleFormChange2(month, e.target.value, null, targetIndex)}
            className="w-full p-1 border rounded"
          />
        </td>
      ))}
    </tr>
))}
</tbody>

      </table>
 {/*      <pre className="mt-4 p-2 bg-gray-100 border border-gray-400 text-sm">
        {JSON.stringify(data, null, 2)}
      </pre> */}
    </div>         
</Grid>
</SoftBox>
</SoftBox>
</Card>
</Grid>
</Grid>
</SoftBox>

<SoftBox py={3} className="customerblock">
            <Grid container spacing={3}>
             <Grid item xs={12} lg={12}>
               <Card sx={{ overflow: "visible" }}>
                 <SoftBox p={3}>
                 <SoftTypography variant="h5" id="form_heading">Sales Team Declaration</SoftTypography>
            
            
                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                     
                                          <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                SO Emp Code.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="ifsc_code"
                                                              name="ifsc_code"
                                                             
                                                              value={formValues.so_emp_code}
                                                              onChange={(e)=>handleFormChange('so_emp_code', e.target.value)}
                                                              onBlur={(e) =>{
                                                               // setEnteredEmployeeCode(e.target.value)
                                                               // setEnteredEmployeeCode("SO")
                                                               setTypedCode(e.target.value)
                                                               setEnteredEmployeeType("SO")
                                                               handleFormChange('so_emp_code', e.target.value)
                                                              } }
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                          <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                SO Name.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_account_number"
                                                              name="bank_account_number"
                                                             
                                                              value={formValues.so_name}
                                                              onChange={(e) => handleFormChange('so_name', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                                        
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                SO Email Address
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_name"
                                                              name="bank_name"
                                                             
                                                              value={formValues.so_email}
                                                              onChange={(e) => handleFormChange('so_email', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                Date.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="date"
                                                              id="bank_branch_name"
                                                              name="bank_branch_name"
                                                             
                                                              value={formatDate(formValues.so_date)}
                                                              onChange={(e) => {
                                                               const raw = e.target.value; // format: "2025-04-20"
                                                               const [year, month, day] = raw.split("-");
                                                               const formatted = `${year}${month}${day}`;
                                                               handleFormChange('so_date', formatted)
                                                              }
                                                               
                                                             }
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                ASM Emp Code.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="ifsc_code"
                                                              name="ifsc_code"
                                                             
                                                              value={formValues.asm_emp_code}
                                                              onChange={(e)=>handleFormChange('asm_emp_code', e.target.value)}
                                                              onBlur={(e) => {
                                                               setTypedCode(e.target.value)
                                                               setEnteredEmployeeType("ASM")
                                                               handleFormChange('asm_emp_code', e.target.value)}}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                ASM Name.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_account_number"
                                                              name="bank_account_number"
                                                             
                                                              value={formValues.asm_name}
                                                              onChange={(e) => handleFormChange('asm_name', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                                        
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                ASM Email Address
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_name"
                                                              name="bank_name"
                                                             
                                                              value={formValues.asm_email}
                                                              onChange={(e) => handleFormChange('asm_email', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                Date.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="date"
                                                              id="bank_branch_name"
                                                              name="bank_branch_name"
                                                             value={formatDate(formValues.asm_date)}
                                                              onChange={(e) => {
                                                               setDateSelected(true)
                                                               const raw = e.target.value; // format: "2025-04-20"
                                                               const [year, month, day] = raw.split("-");
                                                               const formatted = `${year}${month}${day}`;
                                                               handleFormChange('asm_date', formatted)
                                                              }
                                                               
                                                             }
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                RSM Emp Code.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="ifsc_code"
                                                              name="ifsc_code"
                                                             
                                                              value={formValues.rsm_emp_code}
                                                              onChange={(e)=>handleFormChange('rsm_emp_code', e.target.value)}
                                                              onBlur={(e) =>{
                                                               setTypedCode(e.target.value)
                                                               setEnteredEmployeeType("RSM")
                                                               handleFormChange('rsm_emp_code', e.target.value)}}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                RSM Name.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_account_number"
                                                              name="bank_account_number"
                                                             
                                                              value={formValues.rsm_name}
                                                              onChange={(e) => handleFormChange('rsm_name', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                                      
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                RSM Email Address
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_name"
                                                              name="bank_name"
                                                             
                                                              value={formValues.rsm_email}
                                                              onChange={(e) => handleFormChange('rsm_email', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                Date.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="date"
                                                              id="bank_branch_name"
                                                              name="bank_branch_name"
                                                             
                                                              value={formatDate(formValues.rsm_date)}
                                                              onChange={(e) => {
                                                               const raw = e.target.value; // format: "2025-04-20"
                                                               const [year, month, day] = raw.split("-");
                                                               const formatted = `${year}${month}${day}`;
                                                               handleFormChange('rsm_date', formatted)
                                                              }
                                                               
                                                             }
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                ZSM Emp Code.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="ifsc_code"
                                                              name="ifsc_code"
                                                             
                                                              value={formValues.zsm_emp_code}
                                                              onChange={(e)=>handleFormChange('zsm_emp_code', e.target.value)}
                                                              onBlur={(e) => {
                                                               setTypedCode(e.target.value)
                                                               setEnteredEmployeeType("ZSM")
                                                               handleFormChange('zsm_emp_code', e.target.value)}}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                ZSM Name.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_account_number"
                                                              name="bank_account_number"
                                                             
                                                              value={formValues.zsm_name}
                                                              onChange={(e) => handleFormChange('zsm_name', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                                       
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                ZSM Email Address
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_name"
                                                              name="bank_name"
                                                             
                                                              value={formValues.zsm_email}
                                                              onChange={(e) => handleFormChange('zsm_email', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                Date.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="date"
                                                              id="bank_branch_name"
                                                              name="bank_branch_name"
                                                             
                                                              value={formatDate(formValues.zsm_date)}
                                                              onChange={(e) => {
                                                               const raw = e.target.value; // format: "2025-04-20"
                                                               const [year, month, day] = raw.split("-");
                                                               const formatted = `${year}${month}${day}`;
                                                               handleFormChange('zsm_date', formatted)
                                                              }
                                                               
                                                             }
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                NSM Emp Code.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="ifsc_code"
                                                              name="ifsc_code"
                                                             
                                                              value={formValues.nsm_emp_code}
                                                              onChange={(e)=>handleFormChange('nsm_emp_code', e.target.value)}
                                                              onBlur={(e) => {
                                                               setTypedCode(e.target.value)
                                                               setEnteredEmployeeType("NSM")
                                                               handleFormChange('nsm_emp_code', e.target.value)}}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                NSM Name.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_account_number"
                                                              name="bank_account_number"
                                                             
                                                              value={formValues.nsm_name}
                                                              onChange={(e) => handleFormChange('nsm_name', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                                        
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                NSM Email Address
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_name"
                                                              name="bank_name"
                                                             
                                                              value={formValues.nsm_email}
                                                              onChange={(e) => handleFormChange('nsm_email', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                 
                                                        <Grid item xs={12} sm={3}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                Date.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="date"
                                                              id="bank_branch_name"
                                                              name="bank_branch_name"
                                                             
                                                              value={formatDate(formValues.nsm_date)}
                                                              onChange={(e) => {
                                                               const raw = e.target.value; // format: "2025-04-20"
                                                               const [year, month, day] = raw.split("-");
                                                               const formatted = `${year}${month}${day}`;
                                                               handleFormChange('nsm_date', formatted)
                                                              }
                                                               
                                                             }
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                                        <Grid item xs={12} sm={4}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                DSM Code.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="ifsc_code"
                                                              name="ifsc_code"
                                                             
                                                              value={formValues.dsm_emp_code}
                                                              onChange={(e)=>handleFormChange('dsm_emp_code', e.target.value)}
                                                              onBlur={(e) => {
                                                               setTypedCode(e.target.value)
                                                               setEnteredEmployeeType("DSM")
                                                               handleFormChange('dsm_emp_code', e.target.value)}}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                                        <Grid item xs={12} sm={4}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                DSM Name.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_account_number"
                                                              name="bank_account_number"
                                                             
                                                              value={formValues.dsm_name}
                                                              onChange={(e) => handleFormChange('dsm_name', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                 
                                                        <Grid item xs={12} sm={4}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                DSM Email ID
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_name"
                                                              name="bank_name"
                                                             
                                                              value={formValues.dsm_email}
                                                              onChange={(e) => handleFormChange('dsm_email', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>

                                                        <Grid item xs={12} sm={4}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                SRM Code.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="ifsc_code"
                                                              name="ifsc_code"
                                                             
                                                              value={formValues.srm_emp_code}
                                                              onChange={(e)=>handleFormChange('srm_emp_code', e.target.value)}
                                                              onBlur={(e) => {
                                                               setTypedCode(e.target.value)
                                                               setEnteredEmployeeType("SRM")
                                                               handleFormChange('srm_emp_code', e.target.value)}}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                                        
                                                        <Grid item xs={12} sm={4}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                SRM Name.
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_account_number"
                                                              name="bank_account_number"
                                                             
                                                              value={formValues.srm_name}
                                                              onChange={(e) => handleFormChange('srm_name', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                                                        
                                 
                                                        <Grid item xs={12} sm={4}>
                                                          <SoftBox mb={3} id="mkcustomer">
                                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                              <SoftTypography
                                                                component="label"
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                
                                                              >
                                                                SRM Email ID
                                                              </SoftTypography>
                                                            </SoftBox>
                                                            <SoftInput
                                                              type="text"
                                                              id="bank_name"
                                                              name="bank_name"
                                                             
                                                              value={formValues.srm_email}
                                                              onChange={(e) => handleFormChange('srm_email', e.target.value)}
                                                              size="medium"
                                                              
                                                              />
                                                          </SoftBox>
                                                        </Grid>
                     
                                                        
                                 
                                          </Grid>
                   </SoftBox>
            
                 </SoftBox>
               </Card>
             </Grid>
            </Grid>
            </SoftBox>

            <SoftBox py={2} style={{ overflowX: "auto" }}>
                                {[...new Set(approvalFields.final.map(field => field.block))].map((blockName, blockIndex) => (
                                  <div key={blockIndex}>
            
                                    <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
                                    {blockName}
                                  </SoftTypography>
            
            
                                <Grid container alignItems="center" spacing={2}>
            
                                {approvalFields.final.filter(field => field.block === blockName).map((field, index) => (
              <Grid item xs={14} sm={4} key={index + field.name}>
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {fieldDisplayNames2[field.name]}
                </SoftTypography>
            
                {field.type === "dropdown" ? (
                  <div onClick={() => handleDropdownClick(field.apiKey, field.name)}>
                    <SoftInput
                     fullWidth
                      value={field.value}
                      readOnly
                    />
                  </div>
                ) : field.type === "text" ? (
                  <SoftInput
                    type="text"
                    fullWidth
                    disabled={field.name==="Language"?true:false}
                    value={field.name ==="Language"?formValues.language : field.value}
                    onChange={(e) => handleChange(field.name, e.target.value)}
                  />
                ): field.type === "date" ?(
            
                  <SoftInput
                    type="date"
                    fullWidth
                    value={formatDate(field.value)}
                    onChange={(e) => {
                      const raw = e.target.value; // format: "2025-04-20"
                      const [year, month, day] = raw.split("-");
                      const formatted = `${year}${month}${day}`; // "20250420"
                      console.log("here is formatted>> ", formatted)
                      handleChange(field.name, formatted);
                    }}
                  />
              
                ): field.type === "date2" ?(
            
                  <SoftInput
                    type="date"
                    fullWidth
                    value={formatDate(field.value)}
                    onChange={(e) => {
                      const dateObj = new Date(e.target.value);
                      const day = String(dateObj.getDate()).padStart(2, '0');
                      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                      const year = dateObj.getFullYear();
                      const formattedDate = `${year}${month}${day}`;
                      console.log("here is formattedDate>> ", formattedDate)  
                      handleChange(field.name, formattedDate);
                    }}
                  />
              
                ): field.type === "select" ?(
            <div style={{display:'flex'}}>
            <SoftSelect
              
              fullWidth
              options={field.option}
              value={[
                {value: field.value, label: field.value} // Adjust this line to match your data structure
              ]}
              onChange={(e) => handleChange(field.name, e.value)}
            />
            </div>
              
                )
                
                : field.type === "checkbox" ? (
                  <Checkbox
                    checked={field.value==='X'}
                    onChange={(e) => handleChange(field.name, e.target.checked ? "X" : "")}
                  />
                ) : null}
              </Grid>
            ))}
            
                                </Grid>
                                </div>
                  ))}
                              </SoftBox>


         <SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
       {/* Submit Button */}
       <Grid container justifyContent="flex-end" mt={2}>
         <Grid item>
           <SoftButton disabled={panGSTError||panGSTError2} type="submit" variant="contained" color="primary">
             Save & Continue
           </SoftButton>
         </Grid>
       </Grid>
     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

         </form>

         <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
          <SimpleBackdrop openLoader={searchLoader} />
                               <DialogTitle>Select an Option</DialogTitle>
                               <DialogContent>
               
                               <input
                         type="text"
                         placeholder="Search..."
                         value={searchTerm}
                         onChange={(e) => setSearchTerm(e.target.value)}
                         style={{
                           width: "100%",
                           padding: "5px",
                           marginBottom: "10px",
                           fontSize: "12px",
                         }}
                       />
                        <SoftButton
                     onClick={() => handleFormChange('godown_unit', "")}
                     style={{
                       marginBottom: "10px",
                       backgroundColor: "#ccc",
                       border: "none",
                       padding: "5px 10px",
                       fontSize: "12px",
                       cursor: "pointer",
                       borderRadius: "4px"
                     }}
                   >
                     Clear Selection
                   </SoftButton>
                               <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                               <thead>
                               <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                       <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
                                       <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                                     </tr>
                                   </thead>
                                   <tbody>
                                     {kdsdata &&
                                       filteredData?.map((item, index) => (
                                         <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index} onClick={() => handleFormChange('godown_unit',item.value)}>
                                           <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
                                           <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
                                         </tr>
                                       ))}
                                   </tbody>
                                 </Table>
                               </DialogContent>
                             </Dialog> 

            <Dialog open={dialogOpen2} onClose={() => setDialogOpen2(false)}>
            <SimpleBackdrop openLoader={searchLoader} />
                                                               <DialogTitle>Select an Option</DialogTitle>
                                                               <DialogContent>
                                               
                                                               <input
                                                         type="text"
                                                         placeholder="Search..."
                                                         value={searchTerm2}
                                                         onChange={(e) => setSearchTerm2(e.target.value)}
                                                         style={{
                                                           width: "100%",
                                                           padding: "5px",
                                                           marginBottom: "10px",
                                                           fontSize: "12px",
                                                         }}
                                                       />
                                                        <SoftButton
                                                     onClick={() => handleFormChange(selectedZoneName, "")}
                                                     style={{
                                                       marginBottom: "10px",
                                                       backgroundColor: "#ccc",
                                                       border: "none",
                                                       padding: "5px 10px",
                                                       fontSize: "12px",
                                                       cursor: "pointer",
                                                       borderRadius: "4px"
                                                     }}
                                                   >
                                                     Clear Selection
                                                   </SoftButton>
                                                               <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                                                               <thead>
                                                               <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                                                       <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                                                                     </tr>
                                                                   </thead>
                                                                   <tbody>
                                           {
                                            filteredZone.filter(
                                              (item) =>
                                                item.toLowerCase().includes(debouncedSearch.toLowerCase())
                                            )
                                             .map((item, idx) => (
                                                   <tr
                                                     key={idx}
                                                     style={{ whiteSpace: 'nowrap', fontSize: "12px" }}
                                                     onClick={() => handleFormChange(selectedZoneName, item)}
                                                   >
                                                     <td style={{ backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item}</td>
                                                   </tr>
                                                 )
                                               )
                                           }
                                         </tbody>
                                                                 </Table>
                                                               </DialogContent>
                                                             </Dialog> 

                                                             <Dialog open={dialogOpen3} onClose={() => setDialogOpen3(false)}>
                                                                     <SimpleBackdrop openLoader={searchLoader}/>
                                                                                   <DialogTitle>Select an Option</DialogTitle>
                                                                                   <DialogContent>
                                                                   
                                                                                   <input
                                                                             type="text"
                                                                             placeholder="Search..."
                                                                             value={searchTerm}
                                                                             onChange={(e) => setSearchTerm(e.target.value)}
                                                                             style={{
                                                                               width: "100%",
                                                                               padding: "5px",
                                                                               marginBottom: "10px",
                                                                               fontSize: "12px",
                                                                             }}
                                                                           />
                                                                            <SoftButton
                                                                         onClick={() => handleChange(selectedField, "")}
                                                                         style={{
                                                                           marginBottom: "10px",
                                                                           backgroundColor: "#ccc",
                                                                           border: "none",
                                                                           padding: "5px 10px",
                                                                           fontSize: "12px",
                                                                           cursor: "pointer",
                                                                           borderRadius: "4px"
                                                                         }}
                                                                       >
                                                                         Clear Selection
                                                                       </SoftButton>
                                                                                   <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                                                                                   <thead>
                                                                                   <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                                                                           <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
                                                                                           <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                                                                                         </tr>
                                                                                       </thead>
                                                                                       <tbody>
                                                                                         {keySelected &&
                                                                                           kdsdata4[keySelected]?.filter(
                                                                                             (item) =>
                                                                                               item.label.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
                                                                                               item.value.toLowerCase().includes(debouncedSearch.toLowerCase())
                                                                                           ).map((item, index) => (
                                                                                             <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index} onClick={() => {
                                                                                                const valueToSend = selectedField === "Sales Group"
                                                                                                  ? item.label.split('(')[0] // or use regex for more control
                                                                                                  : item.value;
                                                                                                handleChange(selectedField, valueToSend.trim());
                                                                                              }}>
                                                                                               <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
                                                                                               <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
                                                                                             </tr>
                                                                                           ))}
                                                                                       </tbody>
                                                                                     </Table>
                                                                                   </DialogContent>
                                                                                 </Dialog> 

                                        <Dialog open={dialogOpen4} onClose={() => setDialogOpen4(false)}>
                                                            <SimpleBackdrop openLoader={searchLoader}/>
                                                              <DialogTitle>Select an Option</DialogTitle>
                                                              <DialogContent>
                                              
                                                              <input
                                                        type="text"
                                                        placeholder="Search..."
                                                        value={searchTerm2}
                                                        onChange={(e) => setSearchTerm2(e.target.value)}
                                                        style={{
                                                          width: "100%",
                                                          padding: "5px",
                                                          marginBottom: "10px",
                                                          fontSize: "12px",
                                                        }}
                                                      />
                                                       <SoftButton
                                                    onClick={() => handleChange(selectedField, "")}
                                                    style={{
                                                      marginBottom: "10px",
                                                      backgroundColor: "#ccc",
                                                      border: "none",
                                                      padding: "5px 10px",
                                                      fontSize: "12px",
                                                      cursor: "pointer",
                                                      borderRadius: "4px"
                                                    }}
                                                  >
                                                    Clear Selection
                                                  </SoftButton>
                                                              <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                                                              <thead>
                                                              <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                                                      <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                          {
                                           filteredZone.filter(
                                            (item) =>
                                              item.toLowerCase().includes(debouncedSearch.toLowerCase())
                                          )
                                            .map((item, idx) => (
                                                  <tr
                                                    key={idx}
                                                    style={{ whiteSpace: 'nowrap', fontSize: "12px" }}
                                                    onClick={() => handleChange(selectedField, item)}
                                                  >
                                                    <td style={{ backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item}</td>
                                                  </tr>
                                                )
                                              )
                                          }
                                        </tbody>
                                                                </Table>
                                                              </DialogContent>
                                                            </Dialog> 
                                                             <Dialog open={openComment} onClose={()=>setOpenComment(false)} maxWidth="xs" fullWidth>
                                                                          <SimpleBackdrop openLoader={isActive}/>
                                                                                    <DialogTitle>Sync with SAP?</DialogTitle>
                                                                                    <DialogContent>
                                                                                        <SoftButton onClick={saveApproval}  color="success" variant="contained" mt={1}>Sync</SoftButton>
                                                                                    </DialogContent>
                                                                                </Dialog>                                         
         </SoftBox>
        
     </Grid>
    
    </DashboardLayout>
    )
}

export default CustomerForm3